export default {
    "corporate": "Programa corporativo",
    "onboarding": {
        "goal_desc": "Você ganhará %{customPoints} por rastrear sua atividade e %{customPoints} de bônus por completar suas metas. É hora de começar! Você pode ter 3 metas pessoais ativas ao mesmo tempo.",
        "sample_task": {
            "modalActivityTitle": "3 respirações profundas",
            "rewards_featured_title": "Em Destaque",
            "rewards_partners_title": "Parceiros",
            "header_description": "Você ganhará %{customPoints} rastreando sua atividade e completando tarefas, metas e desafios.",
            "icon_text": "Toque no {icon} para rastrear uma respiração profunda.",
            "activityName": "respiração profunda",
            "activityUnit": "respiração"
        },
        "lets_get_started": "Vamos começar!",
        "start_description": "Você ganhará %{customPoints} rastreando sua atividade e completando tarefas, metas e desafios.",
        "complete_and_earn": "Complete e ganhe",
        "did_it": "Consegui!",
        "task_complete": "Tarefa concluída!",
        "breath_sample_task": "Faça um rápido tutorial sobre o rastreamento de atividades",
        "track_a_sample_activity": "Rastreie uma atividade de exemplo",
        "nice": "Legal!",
        "nice_one": "Muito bom!",
        "nice_subtext_1": "Você ganhou %{points} %{customPoints}.",
        "nice_subtext_2": "Ganhar %{customPoints} ajudará você a subir de nível. Cada vez que você sobe um nível, você ganha %{reward_currency}, que podem ser trocados por ótimas ofertas.",
        "nice_subtext_3": "Você ganhará mais pontos ao concluir mais tarefas, rastrear atividades e concluir metas e desafios.",
        "progress_subtitle": "Seus %{customPoints} e progresso são redefinidos a cada %{frequency}.",
        "skip_for_now": "Pular por enquanto",
        "loadingText": "Aguarde enquanto calculamos sua pontuação de bem-estar.",
        "goal_title": "Defina uma meta personalizada",
        "swipe_for_more": "Deslize para ver mais",
        "skip_goals": "Terminei de definir metas por enquanto.",
        "complete_profile": "",
        "level": "Nível",
        "finish_onboarding_action": "Conclua a integração primeiro",
        "vital_stats": {
            "height_ft": "Altura ft.",
            "height_in": "Altura in."
        },
        "rewards": "",
        "welcome": {
            "disclaimerTitle": "Sua privacidade é importante"
        },
        "levels": {
            "title": "Conquistas e recompensas",
            "tableTitle": "Conquista"
        },
        "initialScreen": {
            "title": "Bem-vindo(a) a %{programName}, %{username}!",
            "getRewarded": "Seja recompensado com %{rewardName}",
            "completeAgainst": "Compita com seus colegas",
            "earnPoints": "Ganhe pontos com atividades de bem-estar",
            "levelUp": "Suba de nível e desbloqueie medalhas"
        },
        "starterGoals": {
            "title": "Escolha uma meta",
            "subtitle": "Comece sua jornada de bem-estar com um novo hábito saudável."
        }
    },
    "healthkit_not_available": "Não foi possível conectar-se ao Apple Saúde. No aplicativo Saúde, em Fontes, certifique-se de ter, no mínimo, permissão habilitada para as etapas e pelo menos uma etapa rastreada.",
    "changeCover": "Alterar imagem",
    "joiningCommunityToast": {
        "success": {
            "message": "Você se juntou a %{name} com sucesso",
            "title": "Entrar na comunidade"
        }
    },
    "achievement_starts_date": "Começa: %{date}",
    "editChallenge": "Editar %{challengeName}",
    "createChallenge": {
        "activitiesOrCategory": {
            "subtitle": "Escolha até 5 atividades",
            "title": "O que você gostaria de fazer?",
            "noActivityTitle": "Adicionando atividades",
            "noActivityMessage": "Selecione pelo menos uma atividade ou categoria.",
            "categoryItemDescription": "Todas as atividades na categoria %{category}",
            "addActivityTitle": "Quantos(as) %{unit} de %{activity} você deseja fazer por %{period}?",
            "addCategoryQuantityTitle": "Quantos %{customPoints} você deseja ganhar na categoria %{category}?",
            "subtitleCategories": "Selecione uma categoria. Todas as atividades dessa categoria contribuirão para a meta.",
            "subtitleWithActivities": "%{num} de %{max} atividades selecionadas",
            "selectCategoryMessage": "Todas as atividades da categoria serão selecionadas e as atividades previamente selecionadas serão descartadas.",
            "addActivityTitleTotal": "Quanto(a) %{activity} você deseja fazer em %{period}?"
        },
        "inviteDepartments": {
            "title": "Convidar departamentos"
        },
        "inviteRegions": {
            "title": "Convidar regiões"
        },
        "createInvitation": {
            "selectMore": "Selecione pelo menos 2 %{entity}s!"
        },
        "visibility": {
            "title": "Visibilidade",
            "description": "Todos os usuários de %{programName} podem encontrar os desafios de equipe e juntarem-se a eles."
        },
        "highest": {
            "name": "Mais %{customPoints} vence",
            "description": "Sem limites, mais %{customPoints} fica em 1º lugar"
        },
        "compete": {
            "individual": "Competir individualmente",
            "team": "Competir como equipe"
        },
        "unitType": {
            "title": "Selecione como você completa sua meta",
            "subtitle": "Escolha entre atividades ou uma categoria"
        },
        "category": {
            "name": "Todas as atividades em uma categoria",
            "description": "Por exemplo, rastrear qualquer atividade em 'Movimento'",
            "title": "Escolha uma categoria",
            "subtitle": "Você vai rastrear atividades de qual categoria?"
        },
        "activities": {
            "name": "Atividades selecionadas",
            "description": "Por exemplo, rastrear atividades específicas, como andar de bicicleta",
            "title": "Escolher atividades",
            "subtitle": "Recomendamos se concentrar em uma única atividade, mas você pode adicionar até 5",
            "maxModalTitle": "Máximo de atividades selecionadas",
            "maxModalDescription": "Você pode adicionar no máximo 5 atividades. Toque em Aceitar para prosseguir com suas 5 atividades selecionadas ou Editar para fazer alterações.",
            "warningModalTitle": "Alta dificuldade",
            "warningModalDescription": "Você especificou muitas atividades a serem concluídas por período nesta meta. Tem certeza de que deseja definir uma meta tão desafiadora?",
            "requiredPoints": "necessário para cumprir %{challengeType} do %{period}",
            "noActivitiesModalTitle": "Adicionando atividades",
            "noActivitiesModalDescription": "Selecione pelo menos uma atividade."
        },
        "categoryQuantity": {
            "title": "Defina sua meta de %{customPoints}",
            "subtitle": "Quantos %{customPoints} você deseja ganhar com %{category} a cada %{period}?",
            "subtitleTotal": "Quantos %{customPoints} você deseja ganhar com %{category} %{period}?",
            "text": "Como diretriz, 30 minutos de atividade moderada equivale a cerca de 105 %{customPoints}",
            "noQuantityModalTitle": "Quantidade",
            "noQuantityModalDescription": "Insira um valor",
            "defaultCategoryTitle": "categoria atual"
        },
        "cancel": {
            "title": "Cancelar criação de desafio",
            "message": "Tem certeza de que deseja cancelar a criação do desafio?"
        },
        "createNew": "Criar um novo desafio",
        "chooseChallengeTitle": "Escolha um desafio ou crie o seu",
        "createOwn": {
            "title": "Criar o meu"
        },
        "frequency": {
            "title": "Com que frequência você atingirá sua meta?",
            "subtitle": "Metas diárias são ótimas criadoras de hábitos"
        },
        "startAndDuration": {
            "title": "Escolha a data de início e a duração",
            "subtitle": "",
            "noFieldsTitle": "Data de início e duração",
            "noFieldsMessage": "Preencha a data de início e a duração"
        },
        "finalize": {
            "title": "Revise sua nova meta",
            "subtitle": "",
            "noFieldsTitle": "Nome e instruções",
            "noFieldsMessage": "Preencha o nome e as instruções",
            "name": "Minha meta %{frequency} de %{names}",
            "instructionCategory": "Ganhe %{points} %{customPoints} %{frequency} de todas as atividades de %{category}",
            "instructionActivities": "Rastreie %{items} %{frequency} e ganhe %{points} %{customPoints} %{pointsFrequency}",
            "instructionCompetitionCategory": "Obtenha o máximo de %{customPoints} de todas as atividades de %{category} para vencer esta competição",
            "instructionCompetitionActivities": "Obtenha o máximo de %{customPoints} de %{items} para vencer esta competição",
            "namePlaceholder": "Dê um nome para sua competição",
            "titleChallenge": "Finalizar seu desafio"
        },
        "dailyDescription": "Por exemplo, beber 8 copos de água por dia",
        "weeklyDescription": "Por exemplo, caminhar 150 minutos toda semana",
        "monthlyDescription": "Por exemplo, correr 150 km todo mês",
        "totalDescription": "Por exemplo, pedalar um total de 10.000 km",
        "title": "Desafiar a si mesmo ou outras pessoas?",
        "navigatorTitle": "Criar um desafio",
        "me": {
            "name": "Apenas eu",
            "description": "Desafie-se com uma meta pessoal"
        },
        "others": {
            "name": "Compita com outras pessoas",
            "description": "Compita individualmente ou em equipe"
        },
        "one": {
            "name": "Individualmente",
            "description": "Concluir individualmente com outros usuários"
        },
        "team": {
            "name": "Em equipe",
            "description": "Concluir em equipe com outras equipes"
        },
        "company": {
            "name": "Desafio da empresa",
            "description": "Criar uma competição especial"
        },
        "adminItemTitle": "Como administrador, você pode criar",
        "userOrTeamTitle": "Competir individualmente ou em equipe?",
        "target": {
            "name": "Defina uma meta a cumprir",
            "description": "Desafio que tem um limite superior"
        },
        "typeTitle": "Escolha um tipo de %{challengeType}",
        "teamSizeTitle": "Escolha um tamanho para cada equipe",
        "teamSizeSubtitle": "O tamanho mínimo de uma equipe é %{min} e o máximo é %{max}. Os %{customPoints} da sua equipe são a média de todos os membros da equipe e você só pode ganhar %{customPoints} quando sua equipe atingir o número mínimo de membros.",
        "teamSize": {
            "noFieldsTitle": "Mín. e máx.",
            "noFieldsMessage": "Escolha o número mínimo e o máximo de membros para uma equipe"
        },
        "companyChallengeTitle": "Desafio da empresa",
        "companyChallengeSubtitle": "Você é um administrador. Você pode organizar desafios departamentais e outros tipos de desafios",
        "chooseDepartmentTitle": "Escolha departamentos para competir",
        "chooseRegionTitle": "Escolha regiões para competir",
        "goToChallenge": "Ir para o meu desafio",
        "additional": {
            "title": "Desafio criado",
            "subtitle": "Vamos começar! Convide outras pessoas para participar.",
            "makePublicName": "Tornar público",
            "makePublicDescription": "Qualquer um pode participar",
            "toDirectoryName": "Enviar para o Diretório de Desafios",
            "toDirectoryDescription": "As pessoas podem criar um assim",
            "inviteTitle": "Convidar para o desafio",
            "titleGoal": "Meta criada!"
        },
        "quantityMinimum": {
            "message": "A quantidade mínima exigida é %{quantity}",
            "title": "Quantidade insuficiente"
        },
        "toast": {
            "success": "Seu %{challengeType} foi criado."
        },
        "goToGoal": "Ir para minha meta",
        "navigatorTitleGoal": "Criar uma meta",
        "quantityError": {
            "wholeNumber": "Deve ser um número inteiro",
            "greaterThanZero": "Deve ser maior que 0"
        }
    },
    "wellbeing": {
        "description": {
            "overall": "Sua pontuação de bem-estar é calculada comparando as respostas que você forneceu na pesquisa de bem-estar com as de milhões de outras pessoas de mesma faixa etária e gênero. Sua pontuação demonstra como você se classifica em relação a eles. Sua pontuação será atualizada automaticamente a cada mês de acordo com as mudanças em seus comportamentos de movimento, alimentação e sensações que são inseridos no aplicativo. O estabelecimento consistente de metas e a realização de ações positivas para melhorar sua saúde podem ajudar a aumentar sua pontuação de bem-estar.",
            "excellent": "Sua pontuação de saúde é melhor do que 85% das pessoas de sua idade e gênero. ",
            "very_good": "Sua pontuação de saúde é melhor do que 70-84% das pessoas de sua idade e gênero.",
            "good": "Sua pontuação de saúde é melhor do que 51-69% das pessoas de sua idade e gênero.",
            "fair": "Sua pontuação de saúde é melhor do que 31-50% das pessoas de sua idade e gênero.",
            "poor": "Sua pontuação de saúde é inferior a 70% das pessoas de sua idade e gênero. Nunca é tarde para começar a priorizar sua saúde. Aproveite a nossa plataforma para ajudar você a progredir em sua jornada de bem-estar!",
            "overall_result": "No geral, sua pontuação de bem-estar é %{status}.",
            "category_result": "No geral, sua pontuação de {categoria} é {string}.",
            "goals": "Você não pode vencer sem metas. Defina até 3 metas pessoais e siga em frente. Com o tempo, conforme você fizer mudanças no estilo de vida, verá sua pontuação aumentar."
        },
        "reminder": {
            "title": "É hora de atualizar sua pesquisa de bem-estar!",
            "updateAnswers": "Atualizar minhas respostas"
        },
        "lastUpdated": "Última atualização em %{date}",
        "scoreDescription": {
            "part1": "Sua pontuação é",
            "part2": "pontuação de",
            "belowAverage": "abaixo da média",
            "aboveAverage": "acima da média",
            "part3": "para outros de sua idade e gênero."
        },
        "improveScore": {
            "description": "Sua pontuação é calculada com base em suas respostas da pesquisa de bem-estar e atividades rastreadas. Você pode atualizar suas respostas da pesquisa ou definir novas metas para melhorar.",
            "desc1": "Sua pontuação não pode ficar muito mais alta! Para manter suas rotinas interessantes, desafie-se com objetivos um pouco além de sua capacidade habitual e convide outras pessoas a competir para continuar motivado.",
            "desc2": "Se você está pronto para subir de nível, é hora de aumentar o desafio. Desafie-se com objetivos um pouco além de sua capacidade habitual e convide outras pessoas para competir para se manter motivado.",
            "desc3": "Defina metas pessoais e crie desafios públicos para se manter responsável e motivado. Certifique-se de escolher metas atingíveis e prazos menores – recomendamos 1 semana.",
            "desc4": "É importante estar ativo todos os dias. Se não há muito movimento em sua rotina diária, comece com pequenas metas que correspondam às suas habilidades e interesses. Certifique-se de escolher metas atingíveis e prazos menores – recomendamos 1 semana."
        },
        "recommendedGoals": "Metas recomendadas",
        "recommendedDescription": {
            "desc1": "Você pode definir até ",
            "desc2": "3 metas ",
            "desc3": "para se concentrar em melhorar seu bem-estar. Atualmente você tem "
        },
        "categoryScore": "Sua pontuação de %{category} é ",
        "learnMore": "Saiba mais",
        "youAreSet": "Você está pronto!",
        "goalSetting": "Definição de metas",
        "attention": "Pontuação de %{category} não disponível.",
        "move": {
            "error": "Com base em suas respostas, sua pontuação de movimento não está disponível. "
        },
        "eat": {
            "error": "Você indicou que um profissional de saúde disse que você tem diabetes tipo 2 e que não há tratamento. "
        },
        "feel": {
            "error": "Com base em suas respostas, sua pontuação de sensações não está disponível. "
        },
        "survey": {
            "requiredField": "* este campo é obrigatório"
        },
        "score_info_title": "O que minha pontuação significa",
        "company_average_info": "Média na minha empresa",
        "demographic_average_info": "Média em meu grupo populacional",
        "score": "Pontuação de bem-estar",
        "table": {
            "what_it_means": "O que significa",
            "score": "Pontuação"
        },
        "updated": "Atualizado",
        "label": {
            "excellent": "Excelente",
            "very_good": "Muito bom",
            "good": "Bom",
            "fair": "Regular",
            "poor": "Ruim"
        },
        "activity": {
            "eat": "Atividade de Alimentação 1, Atividade de Alimentação 2, Atividade de Alimentação 3",
            "move": "Atividade de Movimento 1, Atividade de Movimento 2, Atividade de Movimento 3",
            "feel": "Atividade de Sensação 1, Atividade de Sensação 2, Atividade de Sensação 3"
        },
        "score_info_screen": "Como minha pontuação é calculada?",
        "details": "Detalhes",
        "activities": "Atividades",
        "improveCategoryScore": "Melhorar minha pontuação de %{category}",
        "meaning": {
            "heading": "Cálculo de pontuação"
        },
        "score_button": {
            "meaning": "O que essa pontuação significa?"
        },
        "improve": "Ver metas recomendadas",
        "score_text": {
            "demographic": "A pontuação média para sua idade e gênero é",
            "company": "e a pontuação média em sua empresa é"
        },
        "scoreHigher": "superior à média de",
        "scoreLower": "inferior à média de",
        "settedGoals": {
            "noGoals": "Nenhuma meta definida",
            "one": "1 meta definida",
            "n": "%{count} metas definidas"
        },
        "yourScoreIsPoor": "Sua pontuação de %{category} é baixa",
        "unlock": {
            "title": "Desbloqueie sua pontuação de bem-estar",
            "description": "Preencha um breve questionário para saber como sua saúde geral se compara a outras pessoas em seu grupo demográfico."
        },
        "browseAndSet": "Você pode navegar e definir novas metas depois que as atuais terminarem.",
        "excellent": {
            "desc1": "Estilo de vida excepcionalmente saudável",
            "desc2": "Risco de saúde muito baixo"
        },
        "veryGood": {
            "desc1": "Estilo de vida muito saudável",
            "desc2": "Risco de saúde baixo"
        },
        "good": {
            "desc1": "Estilo de vida saudável",
            "desc2": "Risco de saúde médio"
        },
        "fair": {
            "desc1": "Estilo de vida relativamente saudável",
            "desc2": "Risco de saúde acima da média"
        },
        "poor": {
            "desc1": "Risco de saúde alto",
            "desc2": "Recomenda-se mais movimento diário",
            "desc3": "É necessário mais movimento diário"
        },
        "calculateScore": {
            "description": "Quando você conclui a pesquisa de bem-estar, suas respostas são analisadas usando bilhões de variáveis de dados de pessoas de sua idade e sexo. O cálculo também leva em consideração a atividade que você rastreia em %{programName}.\n\nSua pontuação de bem-estar é atualizada regularmente para que você possa vê-la mudar ao longo do tempo."
        },
        "improveYourScore": "Melhorando sua pontuação"
    },
    "challengerCount": "%{num} desafiantes",
    "team_name": "Nome da equipe",
    "syncingDeviceToast": {
        "danger": {
            "message": "Ops… Ocorreu um problema ao sincronizar %{name}. Tente novamente.",
            "title": "Sincronizar"
        },
        "success": {
            "title": "Sincronizar",
            "message": "%{name} sincronizado com sucesso. Suas atividades agora estão atualizadas."
        }
    },
    "allCompanyMembers": "Todos os membros da empresa",
    "allCompanyMembersTeam": "Todos os membros da empresa (Equipe)",
    "successfullyRedeemedItemForConfirmation": "Você resgatou este item com sucesso e um email de confirmação foi enviado para %{email}.",
    "no_all_events_placeholder": "Parece que não há eventos disponíveis para participar no momento. Por que você não cria um?",
    "confirmDeleteAccount": "Confirme a exclusão inserindo o endereço de e-mail associado à sua conta",
    "deleteAccount": "Excluir conta",
    "linkAccounts": "Gerenciar contas vinculadas",
    "titleSlug": {
        "icon_reward_text": "É fácil para os membros qualificados ganhar mais pontos comprando com nossos parceiros ou em um check-up com um dentista do Members’ Choice Advantage usando a cobertura extra.",
        "icon_move_text": "Acompanhar as escolhas saudáveis do dia a dia, como dormir melhor ou comer vegetais, pode render pontos Live Better.",
        "icon_redeem_text": "O Live Better recompensa os membros do Medibank que têm cobertura hospitalar ou extra para cuidar de sua saúde. ",
        "icon_phone_text": "Inscreva-se e comece a resgatar prêmios, como vales-presente de saúde e bem-estar, ou a economizar na cobertura médica. ",
        "wellness": "Bem-vindo ao mundo do bem-estar",
        "goals": "Atinja suas metas",
        "devices": "Mantenha-se no caminho certo",
        "challenges": "Crie desafios",
        "celebrate": "Bem-estar social",
        "habits": "Crie hábitos saudáveis",
        "joinChallenge": "Entre no desafio",
        "getSocial": "Socialize-se",
        "reward": "Seja recompensado por viver uma vida mais saudável.",
        "move": "Movimente-se, coma e sinta-se melhor.",
        "phone": "Viva melhor, sinta-se melhor."
    },
    "viewProgress": {
        "goal": "Ver progresso da meta",
        "challenge": "Ver progresso do desafio",
        "progress": "Ver progresso"
    },
    "vitalStats": {
        "disclaimer": {
            "message": "A inserção dessas informações é opcional, para o seu benefício e particulares."
        }
    },
    "eventBonusPoints": {
        "section": {
            "title": "%{potentialBonusPoints} %{customPoints} de bônus estão disponíveis para este evento!"
        },
        "modal": {
            "paragraph1": "Ao participar deste evento você ganhará %{pointsName} de bônus.",
            "paragraph2": "Todos os %{pointsName} de bônus são concedidos após o evento ser concluído. Você não receberá créditos de bônus para eventos dos quais não participar."
        }
    },
    "EAP": {
        "contactInfo": "Informações de contato",
        "doLater": "Farei isso mais tarde",
        "tellMore": "Conte-me mais",
        "contactMe": "Entre em contato comigo",
        "title": "Programa de assistência ao empregado e família",
        "reachGoal": {
            "title": "Há ajuda disponível",
            "description": "Seu Programa de Assistência ao Empregado e Família (EFAP) fornecido por %{providerName}, oferece uma variedade de serviços de coaching de saúde para ajudar você a atingir seus objetivos de bem-estar.\n\nVocê quer que %{providerName} entre em contato com mais informações?"
        },
        "privacyPolicy": "Política de Privacidade de %{provider}"
    },
    "HRIS": {
        "disclaimer": "Alguns campos são atualizados automaticamente e não podem ser alterados."
    },
    "settingGoals": {
        "description": "Concentrar-se em 3 metas recomendadas por vez aumentará sua probabilidade de sucesso.",
        "title": {
            "one": "Você tem 1 meta definida"
        }
    },
    "auth": {
        "linkAccount": {
            "alreadyLinkedToUser": "Conta já vinculada a um usuário diferente",
            "lastAccountMessage": "Tem certeza de que deseja remover sua última conta vinculada? Uma vez removida, você deve fazer login com o endereço de e-mail %{email} e uma nova senha.",
            "unlinkCorpAccountMessage": "Tem certeza de que deseja remover sua conta corporativa vinculada? Depois de removida, você deve fazer login com o endereço de e-mail %{email} novamente.",
            "alreadyLinked": "Conta já vinculada",
            "unlinkMessage": "Tem certeza que deseja remover uma conta vinculada?"
        },
        "sso": {
            "emailNotVerified": "Seu e-mail não foi verificado."
        },
        "signIn": {
            "dontHaveAccount": "Não tem conta?",
            "enterPIN": "Insira o Número de Identificação do Programa da sua empresa",
            "dontKnowPIN": "Não sabe o seu PIN?",
            "pin": "PIN",
            "register": "Registrar",
            "pinDescription": "Entre em contato com o administrador do programa se não tiver certeza sobre o número de identificação do programa (PIN) exclusivo de sua organização. Se você tiver um PIN e tiver dificuldades para prosseguir para a próxima etapa, entre em contato com support@sproutatwork.com.",
            "keepMeTooltip": "Para sua conveniência, ao marcar esta caixa, sua sessão permanecerá válida por 30 dias. Em dispositivos compartilhados, recomendamos que você desmarque esta caixa e saia quando terminar."
        },
        "signUp": {
            "backToLogin": "Voltar ao login",
            "termsOfService": "Termos de Serviço",
            "privacyPolicy": "Política de Privacidade"
        },
        "createYourAccount": "Crie sua conta",
        "setYourDetails": "Configure seus detalhes",
        "ModaHybridLogin": {
            "noAccessDashboard": "Não tem acesso ao Painel de Membros?",
            "signUpSSOButton": "Inscreva-se através do Painel de Membros Moda",
            "noAccessDashboardWeb": "Se você não tiver acesso ao Painel de Membros, faça login com seu e-mail e senha abaixo.",
            "loginSSOButton": "Faça login através do Painel de Membros Moda"
        }
    },
    "entityHasBeenDeleted": "%{name} foi excluído(a)",
    "track_challenge": {
        "message": {
            "manually": "Rastrear manualmente",
            "automatically": "Rastreado automaticamente com %{appOrDeviceName}",
            "manuallyOrConnect": "Rastrear manualmente ou conectar um aplicativo ou dispositivo",
            "manuallyAndBy": "Rastrear manualmente e automaticamente com %{appOrDeviceName}",
            "reconnectDevice": "Dispositivo necessário. Reconecte seu dispositivo",
            "manualAndAuto": "Rastrear manualmente e automaticamente",
            "trackedAutomatically": "Rastrear automaticamente"
        }
    },
    "signUpPartnerSSOToast": {
        "danger": {
            "title": "Não foi possível registrar-se",
            "message": "Não foi possível recuperar os detalhes de usuário do parceiro. Tente novamente mais tarde"
        }
    },
    "app_device_required": {
        "disclaimer": {
            "title": "Um aplicativo ou dispositivo é necessário para este(a) %{goalName}.",
            "subTitle": "Conecte um aplicativo ou dispositivo"
        }
    },
    "descriptionSlug": {
        "wellness": "Junte-se à comunidade de saúde que ajuda você a definir metas, conectar-se e manter-se no caminho certo.",
        "goals": "Diga-nos no que está trabalhando.  Nós ajudaremos você a chegar lá com as metas recomendadas.",
        "devices": "Sincronize seu dispositivo de fitness ou registre suas atividades e mantenha suas metas de bem-estar no caminho certo.",
        "challenges": "Provoque uma competição amigável.  Crie um desafio e convide outras pessoas para se divertirem.",
        "celebrate": "Fique conectado com os colegas e celebrem seus sucessos juntos.",
        "habits": "Rastreie as atividades de bem-estar para ganhar pontos. Conecte ao seu telefone ou dispositivo vestível para ganhar mais rápido.",
        "joinChallenge": "Veja como você se compara aos seus colegas de trabalho em competições amistosas.",
        "getSocial": "Fique conectado com os colegas e celebrem seus sucessos juntos.",
        "reward_text": "Ganhe pontos por completar atividades diárias e desafios pessoais.",
        "move_text": "Quer seja uma caminhada em torno do quarteirão, cinco minutos de atenção plena ou uma sequência de alimentação saudável, você será recompensado.",
        "phone_text": "Use os pontos para obter descontos em sua cobertura e ótimas ofertas, a escolha é sua.",
        "none": ""
    },
    "core": {
        "featureNotEnabled": "Recurso não habilitado",
        "checkAppVersion": {
            "message": "Parece que seu aplicativo está desatualizado. Instale a atualização mais recente.",
            "button": "Atualizar %{appName}"
        },
        "noConnection": {
            "title": "Sem conexão de rede",
            "description": "Parece que você não está conectado à Internet. Você não conseguirá usar plenamente o aplicativo a menos que tenha uma conexão.",
            "button": "Tentar novamente"
        },
        "uploadPhotoText": "Adicione uma foto para %{entityType}",
        "entities": {
            "community": "comunidade",
            "event": "evento",
            "team": "equipe",
            "goal": "meta",
            "challenge": "desafio",
            "competition": "competição"
        }
    },
    "registration": {
        "login": {
            "errorHeading": "Não foi possível entrar",
            "resetPasswordHeading": "É necessário redefinir a senha"
        },
        "signup": {
            "corporateOrOther": "Não é membro do Medibank? Ou parte de um programa corporativo?",
            "sign_up_here": "Registre-se aqui ",
            "errorHeading": "Não foi possível registrar-se",
            "areYouMedibankMember": "Você é membro do Medibank?",
            "isMedibankMember": "Sou membro",
            "isNotMedibankMember": "Não sou membro"
        },
        "bpidExists": "O e-mail fornecido já está associado a um usuário live better. O e-mail deve ser único.",
        "generalError": "Serviço indisponível no momento"
    },
    "rewardsNoAvailableProducts": "Não há produtos disponíveis no momento.",
    "endedGoal": {
        "timeToTrack": {
            "yes": "Você ainda tem tempo para rastrear!",
            "no": "%{type} terminou"
        },
        "grace": "%{type} pode ter terminado, mas você tem %{n} %{text} para rastrear qualquer atividade esquecida",
        "notGrace": {
            "goal": "Parabéns por completar sua meta! Continue com o excelente trabalho definindo uma nova meta para manter o seu bem-estar no caminho certo.",
            "competition": "Parabéns por completar o desafio! Mantenha seu impulso entrando em outro desafio ou criando o seu próprio."
        }
    },
    "appDeviceModal": {
        "defaultMessage": "Conecte seu dispositivo ou aplicativo e aproveite o rastreamento perfeito. Sua autenticação permite que nosso parceiro de tecnologia \"Sprout\" transfira com segurança seus dados de sua conta %{appDeviceTitle}."
    },
    "noTransactionsMessage": "Parece que você não fez nenhuma transação.",
    "noRedemptionsMessage": "Parece que você ainda não fez nenhum resgate.",
    "challengeCarousel": {
        "emptyChallenge": {
            "subtitle": "Você pode competir em desafios individualmente ou em equipe",
            "prompt": "Não há desafios para entrar agora. Por que não criar um?"
        },
        "createChallengeButton": "Criar um desafio"
    },
    "eventCarousel": {
        "emptyEvents": {
            "subtitle": "Os eventos podem ser apenas para convidados ou abertos para qualquer pessoa.",
            "button": "Criar um evento"
        },
        "emptyEventsMessage": "Não há eventos para ingressar no momento. Por que não criar um?"
    },
    "appnameLiveBetter": "Live Better",
    "appnameTelus": "Bem-estar",
    "appnameUPnGo": "UPnGO",
    "personal_goal": {
        "carousel": {
            "headingNoSet": "Você não tem metas definidas!",
            "descriptionNoSet": "Melhore sua pontuação de bem-estar definindo algumas metas. Comece rapidamente com uma meta recomendada, escolha no catálogo ou crie a sua própria.",
            "descriptionSet": "Você pode definir uma das metas recomendadas que temos para você, navegar pelo catálogo completo ou criar sua própria meta.",
            "action_text": "Defina uma nova meta",
            "heading_singular": "Você pode definir mais 1 meta",
            "heading_plural": "Você pode definir mais %{number} metas"
        },
        "heading": "Metas pessoais",
        "single": "Meta pessoal"
    },
    "settingGoal": {
        "yourGoal": "Seus(uas) %{units}",
        "yourGoalDescription": "Você está no caminho! Os(as) seguintes %{units} serão definidos(as) e começarão imediatamente.",
        "selectedGoals": "Metas selecionadas",
        "recommendedDescription": {
            "maximumSet": "Você definiu o número máximo de metas. Você pode navegar e definir novas metas depois que as atuais forem concluídas.",
            "maximumSetTitle": "Você tem %{count} metas definidas"
        }
    },
    "activityLogRemoved": {
        "single": {
            "success": "A atividade foi removida",
            "info": "Algo deu errado. Tente novamente.",
            "danger": "Algo deu errado. Tente novamente."
        },
        "plural": {
            "success": "Atividades foram removidas",
            "info": "Algo deu errado. Tente novamente.",
            "danger": "Algo deu errado. Tente novamente."
        },
        "success": "A atividade foi removida",
        "info": "A atividade não foi removida. Tente novamente.",
        "danger": "A atividade não foi removida. Tente novamente."
    },
    "participants": "Participantes",
    "members": "Membro(s)",
    "timeSittingInformationOld": "As diretrizes recomendam:\n- Minimizar a quantidade de tempo que passa sentado.\n- Interromper longos períodos sentado com a maior frequência possível.",
    "timeSittingInformation": {
        "title": "As diretrizes recomendam:",
        "list": "- Minimizar a quantidade de tempo que passa sentado.\n- Interromper longos períodos sentado com a maior frequência possível."
    },
    "activityLevelInformationOld": "As diretrizes recomendam:\n- Ser ativo na maioria dos dias da semana, de preferência todos os dias.\n- Acumular mais de 150 minutos de atividade física de intensidade moderada por semana.\n- Realizar atividades de fortalecimento muscular pelo menos 2 dias por semana.",
    "activityLevelInformation": {
        "title": "As diretrizes recomendam:",
        "list": "- Ser ativo na maioria dos dias da semana, de preferência todos os dias.\n- Acumular mais de 150 minutos de atividade física de intensidade moderada por semana.\n- Realizar atividades de fortalecimento muscular pelo menos 2 dias por semana."
    },
    "viewGuidelines": "Ver diretrizes",
    "corporateAccountLink": {
        "verification": {
            "title": "Verifique seu endereço de e-mail de trabalho",
            "description": "Você precisará verificar seu endereço de e-mail de trabalho para concluir o processo de vinculação. Siga as instruções enviadas para:"
        }
    },
    "invitation": {
        "findFriendsAndFamily": "Encontre amigos e familiares",
        "findFriends&Family": "Encontre amigos e familiares",
        "tapToAddFriendsAndFamily": "Toque para adicionar aos amigos e familiares",
        "addedFriendsAndFamily": "Adicionado aos amigos e familiares",
        "whoYouAreLookingFor": "Não vê quem você está procurando?",
        "inviteWithEmail": "Convide com e-mail",
        "sentInvitations": "Convites enviados",
        "foundPerson": "Encontramos essa pessoa com um e-mail correspondente",
        "youAreBoth": "Vocês dois estão em %{entityName}",
        "youAreBothMore": "Vocês dois estão em %{entityName} e mais %{n}",
        "noFriendsAndFamilyAdded": "Parece que você ainda não adicionou nenhum amigo ou familiar.",
        "sendInvitation": "Enviar convite",
        "youHaveNoSentInvitations": "Você não enviou nenhum convite",
        "toast": {
            "success_title": "Convite enviado",
            "success_description": "%{invite_email} verá o convite em sua caixa de entrada",
            "danger_title": "O convite falhou",
            "danger_description": "Tente novamente mais tarde"
        },
        "email": {
            "invalid_email": "Insira um endereço de e-mail válido"
        },
        "inviteOthers": "Convidar outras pessoas",
        "searchForSomeone": "Procurar alguém",
        "searchForOthersToInvite": "Procure outras pessoas para convidar",
        "programNameOnly": {
            "title": "%{programName} apenas",
            "description": "Este(a) {entityType} está disponível apenas para pessoas que fazem parte de %{programName}"
        },
        "domainCannotBeUsed": "Este domínio não pode ser usado com %{programName}",
        "actionSearchByEmail": "Convide por e-mail se você não conseguir encontrar quem procura",
        "send": "Enviar",
        "addEmailToList": "Adicionar e-mail à lista",
        "toBeSent": "Convites a serem enviados",
        "noInvitationsToBeSent": "Não há convites",
        "removeEmailConfirmation": "Tem certeza que deseja remover este e-mail da lista?",
        "yes": "Sim",
        "no": "Não",
        "foundByEmail": "Encontramos essa pessoa com um e-mail correspondente",
        "addToFriendsAndFamily": "Adicionar a amigos e familiares",
        "alreadyAddedEmail": "Você já adicionou este e-mail à lista"
    },
    "pointsCurrencyAdditionalInfo": "Seus %{points_name} e níveis recomeçam a cada %{period}. Todas as suas atividades rastreadas contribuem para o seu nível geral no período.",
    "rankLabel": "Classificação",
    "leaderboards": {
        "loadingLabel": "Carregando tabelas de classificação... Isso pode levar alguns minutos - parece que todo mundo está começando a se exercitar!"
    },
    "feeds": {
        "emptyListHomePage": "Não há postagens para mostrar ainda. Tente ajustar o stream para mostrar mais postagens.",
        "viewingPostsFrom": "Visualizando postagens de",
        "postActivity": "Adicione um comentário ou foto sobre suas atividades!",
        "indicatorLoader": {
            "defaultTitle": "Atualizando...",
            "successfulLoadedTitle": "Sincronizado e atualizado..."
        },
        "inapropriateTextError": {
            "message": "O conteúdo da sua mensagem pode ser impróprio. Tente usar uma linguagem mais amigável."
        },
        "postImageError": {
            "title": "Desculpe, não podemos publicar isso",
            "message": "A imagem que você adicionou pode ser imprópria. Tente outra."
        }
    },
    "syncModal": {
        "connect": {
            "title": "Conectando %{name}",
            "description": "Para conectar seus dados %{name} à sua conta, conclua as seguintes etapas:",
            "firstStep": "Baixe e instale o aplicativo móvel %{appName} do(a) %{storeName}",
            "fourthStep": "Selecione para se conectar com %{name}",
            "fifthStep": "Quando solicitado, selecione as métricas de saúde para sincronizar com %{appName} e pressione 'Concluído'",
            "additionalInfo": "Observe que para acionar a sincronização do aplicativo Health, %{appName} deve ser aberto. Embora você não precise manter o aplicativo aberto, pode levar uma hora para que a sincronização seja concluída e apareça em seu registro de atividades."
        },
        "title": "Sincronizando %{name}",
        "description": "Para sincronizar os dados de %{name} com sua conta, conclua as seguintes etapas:",
        "steps": {
            "one": "Acesse o aplicativo %{appName} em seu telefone",
            "two": "Abra a seção Aplicativos e Dispositivos em seu perfil",
            "three": "Pressione o botão de sincronização próximo a %{name}",
            "iPhone": "Acesse o aplicativo %{appName} em seu iPhone"
        }
    },
    "accountLinkingToast": {
        "success": {
            "title": "Conta de trabalho",
            "message": "Conta conectada com sucesso"
        },
        "danger": {
            "message": "Erro ao conectar conta"
        },
        "conflict": {
            "message": "A conta já está vinculada a um usuário diferente"
        }
    },
    "accountUnlinkingToast": {
        "success": {
            "title": "Conta de trabalho",
            "message": "Conta desconectada com sucesso"
        },
        "danger": {
            "title": "Vincular contas",
            "message": "Erro ao desconectar conta"
        }
    },
    "earnMoreWithPartners": "Ganhe mais com parceiros",
    "connectPartnersToEarnByShopping": "Conecte suas contas e ganhe mais %{unit_type} comprando com parceiros %{program_name}.",
    "viewAllPartners": "Ver todos os parceiros",
    "myPartnerMemberships": "Minhas assinaturas de parceiros",
    "linkAccount": "Vincular assinatura",
    "linkToPartner": "Vincular ao parceiro",
    "linkingError": "Ocorreu um problema ao vincular sua conta. Tente novamente.",
    "linkPending": "Vinculação pendente",
    "unlinkAccount": "Desvincular conta",
    "linkedToPartnerName": "Vinculado a %{partner_name}",
    "linked": "Vinculado",
    "permission": {
        "facebookTitle": "Registrar-se com Facebook",
        "googleTitle": "Registrar-se com Google",
        "facebookDescription": "Ao registrar-se com o Facebook, você vai precisar conceder permissão ao nosso parceiro de tecnologia \"Sprout\" para acessar sua identidade e criar sua conta %{programName}.",
        "googleDescription": "Ao registrar-se com o Google, você vai precisar conceder permissão ao nosso parceiro de tecnologia \"Sprout\" para acessar sua identidade e criar sua conta %{programName}.",
        "camera": {
            "title": "Acesso à câmera",
            "description": "O acesso à câmera é necessário para tirar fotos. Nas configurações do iPhone, toque em %{appName} e ative a Câmera.\n\nObserve que você pode perder quaisquer alterações não salvas."
        },
        "notNow": "Agora não",
        "openSettings": "Abrir configurações",
        "photos": {
            "title": "Permita acesso às fotos",
            "description": "Isso permite que você compartilhe fotos de sua biblioteca e salve-as no rolo da câmera. Nas configurações do iPhone, toque em %{appName} e altere as Fotos para Ler e salvar.\n\nObserve que você pode perder quaisquer alterações não salvas."
        }
    },
    "firstNameContainsSpecialChar": "Seu nome pode conter apenas letras, hifens - e apóstrofos em inglês",
    "lastNameContainsSpecialChar": "Seu sobrenome pode conter apenas letras, hifens - e apóstrofos em inglês",
    "goToPartnerSite": "Ir para o site parceiro",
    "noPartnersFound": "Nenhum parceiro encontrado",
    "noLinkedPartners": "Nenhum parceiro vinculado",
    "noPartnersInCategory": "Nenhum parceiro na categoria",
    "partnerAccountPendingVerification": "Verificação de conta pendente",
    "shopWithPartner": "Comprar com parceiro",
    "shopWithPartnerName": "Comprar com %{partner_name}",
    "linkToPartnerName": "Vincular a %{partner_name}",
    "earnPartnerMembershipIdentifier": "Identificador de assinatura",
    "earnPartnerAccountPendingAddLink": "Sua assinatura está sendo vinculada e pode levar vários dias para ser concluída.",
    "earnPartnerAccountPendingRemoveLink": "Sua assinatura está sendo desvinculada e pode levar vários dias para ser concluída.",
    "linkStatusUpdating": "Atualização do status do link",
    "activityTracking": {
        "firstActivityModal": {
            "description1": "Parabéns por adicionar suas primeiras atividades! \n\nSe quiser, você pode adicionar mais atividades para hoje e outros dias. Quando terminar as atividades de hoje, toque",
            "description2": "na próxima tela quando você não tiver mais nada para rastrear."
        },
        "listTitle": "Atividades rastreadas em",
        "dots": {
            "tracked": "Atividades rastreadas neste dia",
            "added": "Atividades foram adicionadas e pendentes de envio"
        },
        "trackedActivitiesFor": "Atividades rastreadas para %{date}",
        "activityTracking": "Rastreamento de atividades",
        "addedPending": "Adicionado (envio pendente)",
        "search": {
            "description1": "Toque",
            "description2": "para ver as atividades disponíveis ou pesquise uma atividade específica"
        },
        "addActivity": "Adicionar atividade",
        "addAnotherActivity": "Adicionar outra atividade"
    },
    "rewardsBalance": "Saldo de %{currencyName}: %{points}",
    "membershipIdentifierRequiredError": "Seu identificador de assinatura é necessário para vincular",
    "incorrectValueInRange": "Insira um valor entre %{min} e %{max}",
    "joinTeam": {
        "title": "Junte-se à equipe",
        "createInsteadText": "Junte-se ou crie uma equipe para participar deste desafio"
    },
    "teamRank": "Classificação da equipe",
    "teamScore": "Pontuação da equipe",
    "appsDevices": {
        "infoText": "Você será solicitado a autorizar nosso parceiro de tecnologia Sprout Wellness Solutions, Inc. a acessar seus dados de saúde ao adicionar um aplicativo ou dispositivo.",
        "connectModal": {
            "title": "Autorização",
            "paragraph1Part1": "Você será solicitado a autorizar nosso parceiro de tecnologia",
            "paragraph1Part2": "Sprout Wellness Solutions, Inc.",
            "paragraph1Part3": "a acessar seus dados de saúde.",
            "paragraph2Desc1": "Sua autorização permite que o",
            "paragraph2Desc2": "Sprout",
            "paragraph2Desc3": "sincronize com segurança seus",
            "paragraph2Desc4": "dados com",
            "paragraph2Desc5": ", e ajuda você a ganhar mais %{pointsName}!"
        },
        "statusAlert": {
            "connectMessage": "Conecte um aplicativo ou dispositivo de rastreamento de atividades e torne a sincronização e o rastreamento de atividades muito mais fáceis",
            "connectAction": "Conecte um aplicativo ou dispositivo",
            "errorMessage": "Alguns de seus aplicativos ou dispositivos conectados não conseguem sincronizar",
            "warningMessage": "Alguns de seus aplicativos ou dispositivos conectados podem ter um problema de conexão",
            "errorAction": "Corrigir este erro",
            "warningAction": "Corrigir este aviso",
            "syncingError": "Erro de sincronização",
            "syncingIssue": "Problema de sincronização"
        },
        "deviceDetails": {
            "warningMessage": "Este aplicativo ou dispositivo está com problema para sincronizar",
            "errorMessage": "Este aplicativo ou dispositivo não consegue sincronizar",
            "warningAction": "Dispensar aviso",
            "noActivities": "Nenhuma atividade de %{deviceName} foi sincronizada com %{programName} nos últimos 7 dias. \n\nPode levar até uma hora para que as atividades apareçam aqui após serem rastreadas com %{deviceName}.\n\nSe você tiver outro aplicativo ou dispositivo conectado e mais etapas tiverem sido rastreadas pelo outro aplicativo ou dispositivo, você verá a atividade lá. Caso contrário, tente desconectar e reconectar %{deviceName}. Se for solicitado a você que autentique ou conceda permissões, certifique-se de habilitar os dados de atividade e de usar a mesma conta para autenticação que aquela usada para rastrear as atividades. Confira as etapas da solução de problemas para obter mais informações.  "
        },
        "troubleshooting": "Solução de problemas",
        "deviceItem": {
            "error": "Erro de conexão",
            "warning": "Aviso de conexão",
            "unableToSync": "Não foi possível sincronizar"
        },
        "platformDevice": {
            "defaultApp": "O aplicativo de saúde padrão do seu dispositivo é",
            "continueMore": "Continuar para mais aplicativos e dispositivos"
        }
    },
    "friendsAndFamily": {
        "learnMore": "Saiba mais sobre amigos e familiares",
        "learnModal": {
            "title": "Sobre amigos e familiares",
            "description": "Depois de adicionar alguém a seus amigos e familiares, você pode escolher compartilhar suas postagens em %{programName} apenas com eles.\n\nVocê também pode filtrar as postagens que vê em %{programName} apenas para as pessoas em sua lista de amigos e família, se eles postaram para todos ou para você.",
            "description_line1": "Depois de adicionar alguém aos seus amigos e familiares, você pode optar por compartilhar suas postagens no %{programName} apenas com eles.",
            "description_line2": "Você também pode filtrar as postagens que vê em %{programName} apenas para as pessoas em sua lista de amigos e familiares, se elas postaram para todos ou para você.",
            "whatIconsMean": "O que significam os ícones",
            "canAdd": "Adicionar",
            "added": "Adicionado"
        },
        "searchDescription1": "Procure pessoas para adicionar aos seus amigos e familiares.",
        "searchDescription2": "Não vê quem você está procurando? Convide-os por e-mail.",
        "friends&Family": "Amigos e familiares",
        "managingTour": {
            "title": "Gerenciando amigos e familiares",
            "body": "Se você gostaria de remover alguém de seus amigos e familiares, toque no ícone"
        },
        "removeOption": "Remover de amigos e familiares",
        "inviteDescription1": "Procure seus amigos e familiares.",
        "inviteDescription2": "Não vê quem você está procurando?"
    },
    "deletePlatformInvitationToast": {
        "success": {
            "message": "As postagens que você compartilha apenas com amigos e familiares não estarão mais visíveis para %{userFirstName}."
        }
    },
    "skipAll": "Pular tudo",
    "smallMin": "min",
    "eap": {
        "skipModal": {
            "title": "Você tem certeza?",
            "description": "Você sempre pode entrar em contato com o Programa de Assistência ao Empregado e Família a partir do seu perfil quando precisar."
        },
        "contact": {
            "whatIsBestNumber": "Qual é o melhor número para entrar em contato com você?",
            "whatIsBestTime": "Qual é o melhor horário para entrar em contato com você?",
            "morning": "Manhã",
            "afternoon": "Tarde",
            "evening": "Noite",
            "additionalDetails": "Detalhes adicionais sobre a hora\/data em que você gostaria que entrássemos em contato",
            "message": "Entre em contato comigo %{weekDay} pelo número %{phoneNumber}. Informações adicionais: %{additional}",
            "description": "Observação: Recomendamos que você escolha um horário fora do seu horário de trabalho e opte por um lugar onde possa ter uma conversa privada. Inclua seu fuso horário."
        },
        "phoneNumber": {
            "empty": "Este campo não pode estar vazio",
            "missingDigits": "O número de telefone deve conter pelo menos 4 dígitos"
        },
        "myEAP": "Meu programa de assistência ao empregado e família"
    },
    "healthSurveySkipAllTitle": "Pular pesquisa de bem-estar",
    "healthSurveySkipAllAlert": "Tem certeza de que deseja pular todas as perguntas restantes da pesquisa de bem-estar?",
    "eapSavingWithoutDataToast": {
        "danger": {
            "title": "Programa de assistência ao empregado e família",
            "message": "Forneça seu número de telefone e o melhor horário de contato"
        }
    },
    "allMyChallenges": "Meus desafios",
    "invitedChallenges": "Convites",
    "companyChallenges": "Desafios da empresa",
    "completedChallengesEmpty": "Parece que você ainda não completou nenhum desafio.",
    "myChallengesEmpty": "Parece que você ainda não entrou em nenhum desafio.",
    "allChallengesEmpty": "Não há desafios.",
    "startsToday": "Começa hoje",
    "startedDaysAgo": "Iniciado %{dayCount} dias atrás",
    "startsInDays": "Começa em %{dayCount} dias",
    "privacyOn": "Desligado",
    "privacyOff": "Ligado",
    "dashboard": {
        "viewLeaderboard": "Ver tabela de classificação",
        "timePeriodProgress": "Seu progresso neste %{period}",
        "howToEarn": "Como ganhar pontos"
    },
    "privacyChangeConfirmationMessage": "Alterar privacidade?",
    "privacySettingsTitle": "Privacidade",
    "privacySettingsDescription": "Você pode controlar a visibilidade de sua imagem, nome e perfil para outros usuários. ",
    "mainLeaderBoardSettingsTitle": "?Tabela de classificação geral",
    "challengeLeaderBoardSettingsTitle": "?Tabela de classificação do desafio",
    "managePrivacySettingUrlTitle": "Gerenciar configurações de privacidade",
    "onboardingFamilyPrivacySettingsMessageOn": "Você está visível nos resultados de pesquisa de amigos e familiares. Você pode optar por se ocultar dos resultados da pesquisa.",
    "onboardingFamilyPrivacySettingsMessageOff": "Atualmente, suas configurações de privacidade ocultam você nos resultados de pesquisa de amigos e familiares.",
    "challengeInvitationPrivacySettingsMessageOn": "Você está visível nos resultados de pesquisa de convite de desafio. Você pode optar por se ocultar dos resultados da pesquisa.",
    "challengeInvitationPrivacySettingsMessageOff": "Atualmente, suas configurações de privacidade ocultam você dos resultados de pesquisa de convite de desafio.",
    "challengeParticipationPrivacySettingsMessageOn": "Você está listado como participante deste desafio. Você pode escolher se ocultar como participante de desafios.",
    "challengeParticipationPrivacySettingsMessageOff": "Atualmente, suas configurações de privacidade ocultam você da lista de participantes.",
    "communityInvitationPrivacySettingsMessageOn": "Você está visível nos resultados de pesquisa de convites da comunidade. Você pode optar por se ocultar dos resultados da pesquisa.",
    "communityInvitationPrivacySettingsMessageOff": "Atualmente, suas configurações de privacidade ocultam você dos resultados de pesquisa de convite da comunidade.",
    "communityParticipationPrivacySettingsMessageOn": "Você está listado como membro desta comunidade. Você pode escolher se ocultar como membro de comunidades.",
    "communityParticipationPrivacySettingsMessageOff": "Atualmente, suas configurações de privacidade ocultam você da lista de membros.",
    "eventInvitationPrivacySettingsMessageOn": "Você está visível nos resultados de pesquisa de convites para eventos. Você pode optar por se ocultar dos resultados da pesquisa.",
    "eventInvitationPrivacySettingsMessageOff": "Atualmente, suas configurações de privacidade ocultam você dos resultados de pesquisa de convites para eventos.",
    "eventParticipationPrivacySettingsMessageOn": "Você está listado como participante deste evento. Você pode optar por se ocultar como participante de eventos.",
    "eventParticipationPrivacySettingsMessageOff": "Atualmente, suas configurações de privacidade ocultam você da lista de participantes.",
    "mainLeaderboardPrivacySettingsMessageOn": "Você é exibido nas tabelas de classificação gerais. Você pode escolher se ocultar, o que removerá sua classificação, imagem e nome quando outros visualizarem as tabelas de classificação gerais.",
    "mainLeaderboardPrivacySettingsMessageOff": "Atualmente, suas configurações de privacidade ocultam você quando outros visualizam as tabelas de classificação gerais.",
    "challengeLeaderboardPrivacySettingsMessageOn": "Você é exibido nas tabelas de classificação dos desafios. Você pode escolher se ocultar, o que removerá sua classificação, imagem e nome quando outros visualizarem as tabelas de classificação dos desafios.",
    "challengeLeaderboardPrivacySettingsMessageOff": "Atualmente, suas configurações de privacidade ocultam você quando outros visualizam as tabelas de classificação dos desafios.",
    "thumbsUpConfirmationTitle": "Curtir",
    "thumbsUpConfirmationDescriptionline1": "Parabéns, você está prestes a dar sua primeira curtida e encorajar outras pessoas!",
    "thumbsUpConfirmationDescriptionline2": "Você será incluído na lista de pessoas que curtiram esta postagem e outras pessoas poderão ver sua foto, nome e seu perfil.",
    "thumbsUpConfirmationButtonOk": "Curtir",
    "commentToActionInfoTitle": "O que os outros veem?",
    "commentToActionMessage": "Quando você comenta, outras pessoas podem ver sua foto, nome e perfil.",
    "postToActionTitle": "Quem vê esta postagem?",
    "postToActionMessageLine1": "Ao criar uma postagem, você pode controlar quem pode vê-la e até mesmo postar apenas para você.",
    "postToActionMessageLine2": "As postagens que você compartilha com outras pessoas mostram sua foto e seu nome, e outras pessoas podem ver seu perfil",
    "privateUsersDescriptionChallenge": "Este(s) participante(s) se ocultou(aram) da lista",
    "privateUsersFirstNamePlaceHolderChallenge": "%{n}",
    "privateUsersLastNamePlaceHolderChallenge": "participante(s) privado(s)",
    "privateUsersDescriptionEvent": "Este(s) participante(s) se ocultou(aram) da lista",
    "privateUsersFirstNamePlaceHolderEvent": "%{n}",
    "privateUsersLastNamePlaceHolderEvent": "participante(s) privado(s)",
    "privateUsersDescriptionCommunity": "Este(s) membro(s) se ocultou(aram) da lista",
    "privateUsersFirstNamePlaceHolderCommunity": "%{n}",
    "privateUsersLastNamePlaceHolderCommunity": "membro(s)",
    "noPrivacySettings": "Sem configurações de privacidade",
    "linkToPartnerNameWebsite": "Link via site de %{partner_name}",
    "linkToPartnerWebsiteUrl": "URL do site parceiro",
    "start_end_time": "Horário de início e término:",
    "joinCreateTeamPrivacyDisclaimer": "Sua foto, nome e perfil sempre estarão visíveis para qualquer pessoa ao visualizar sua equipe em um desafio, mesmo se você tiver alterado suas configurações de privacidade para Privado.",
    "carouselInstructions": {
        "swipe": "Deslize os cartões para ver todas as suas metas e desafios.",
        "click": "Clique nos cartões para ver todas as suas metas e desafios."
    },
    "achieved": "Horas",
    "hours": "alcançadas",
    "createCommunityFlow": {
        "navigatorTitle": "Criar comunidade",
        "stepType": {
            "title": "Visibilidade da comunidade",
            "subTitle": "Quem poderá ver e participar da comunidade?",
            "privateName": "Privado",
            "publicName": "Público",
            "privateDescription": "Apenas as pessoas que você convidar poderão ver ou participar da comunidade",
            "publicDescription": "Qualquer pessoa pode ver e participar desta comunidade"
        },
        "stepName": {
            "title": "Dê um nome para sua comunidade",
            "subTitle": "Dê um nome para sua comunidade que permitirá que as pessoas saibam do que se trata.",
            "namePlaceholder": "Nome da comunidade",
            "noFieldsTitle": "Nome",
            "noFieldsMessage": "Nenhum nome foi dado"
        },
        "stepDescription": {
            "title": "Sobre sua comunidade",
            "subTitle": "Conte aos outros do que se trata sua comunidade.",
            "descriptionPlaceholder": "Descrição (opcional)",
            "noFieldsTitle": "Descrição",
            "noFieldsMessage": "Nenhuma descrição fornecida"
        },
        "stepImage": {
            "uploadPhotoButtonTitle": "Adicione uma foto"
        },
        "stepJoin": {
            "title": "Encontramos comunidades semelhantes",
            "subTitle": "Você gostaria de entrar em uma dessas comunidades em vez de criar outra?"
        },
        "createNew": "Criar uma nova comunidade"
    },
    "challengeCard": {
        "allActivities": "Todas as atividades na",
        "category": "categoria"
    },
    "myLinkedPartners": "Meus parceiros vinculados",
    "leaderboardPosition": "Posição geral na tabela de classificação",
    "remainingInChallenge": "remanescentes no desafio",
    "todays_progress": "Progresso de hoje",
    "this_weeks_progress": "Progresso desta semana",
    "this_months_progress": "Progresso deste mês",
    "achievement": "conquista",
    "challengeCardHeader": {
        "challenge": "Desafio",
        "recommended_personal_goals": "Meta pessoal recomendada",
        "personal_goal": "Meta pessoal",
        "competition": "Competição",
        "recommended_goals": "Meta recomendada",
        "team_competition": "Competição de equipes",
        "team": "Equipe"
    },
    "MyMedibank": "Meu Medibank",
    "Google": "Google",
    "Facebook": "Facebook",
    "errorEntityTimeMessage": "O horário de término não pode ser anterior ao horário de início",
    "company": "Empresa",
    "lessThan1DayRemain": "menos de 1 dia",
    "lessThan1HourRemain": "menos de 1 hora",
    "remainingToday": "restante hoje",
    "periodEndsDateAndTime": "O período termina em %{date}, %{time}",
    "moreToGo": "%{n} %{unit} mais para começar",
    "reachedYourGoal": "Você atingiu sua meta %{period}!",
    "reachedYourGoalToday": "Você atingiu sua meta hoje!",
    "editProfileItemCorrectRange": "Forneça um valor válido de %{itemName} entre o valor mínimo %{min} e o valor máximo %{max}",
    "invalidUrl": "URL inválido",
    "activityLogChanged": {
        "success": "As alterações na atividade foram salvas",
        "info": "Algo deu errado... Tente novamente.",
        "danger": "Algo deu errado... Tente novamente."
    },
    "discardAlert": {
        "createChallenge": "Tem certeza de que deseja descartar este %{challengeType}?",
        "inviteByEmail": "Tem certeza de que deseja descartar as alterações?",
        "createTeam": "Tem certeza de que deseja cancelar a criação desta equipe?",
        "cancel": "Cancelar",
        "confirm": "Sim, descartar"
    },
    "entityInvalidNameError": "O nome do(a) %{entity} deve conter apenas números ou valor de string e não pode estar vazio",
    "accept": "Aceitar",
    "sync_now": "Sincronizar agora",
    "reconnect_device": "Reconectar",
    "supported_activities": "Atividades suportadas",
    "recentlySynced_activity": "Atividade sincronizada recentemente",
    "noSyncedActivity_sevenDays": "Nenhuma atividade foi sincronizada nos últimos 7 dias",
    "recentActivityLog": {
        "convertingActivityPoints": "Sincronizando atividades...",
        "activityMinuteOrTwo": "Isso pode levar um ou dois minutos...",
        "noNewActivities": "Nenhuma nova atividade adicionada... Pode levar até uma hora para que as novas atividades sejam sincronizadas."
    },
    "deleteCommunityCheckbox": "Eu entendo que isso não pode ser desfeito",
    "createEvent": {
        "type": {
            "company": "Evento da empresa",
            "user": "Evento do usuário",
            "title": "Tipo de evento"
        },
        "privacy": "Privacidade (mostrar participantes ou não)",
        "cost": "Custo",
        "associated": {
            "location": "Local Associado",
            "department": "Departamento Associado"
        },
        "maxParticipants": "Máx. de Participantes (opcional)",
        "errorMessage": {
            "limit": "Não pode ser maior que %{maxValue}",
            "negative": "Não pode ser um valor negativo",
            "selectedLocations": "Selecione um ou mais locais"
        },
        "selectLocations": "Locais selecionados",
        "createNew": "Criar um novo evento"
    },
    "selected": "Selecionado",
    "deleteEventButton": "Excluir este evento",
    "notification": {
        "priorityNotification": {
            "title": "Você tem atualizações importantes não lidas",
            "subtitle": "Toque para ler agora",
            "subtitleWeb": "Clique para ler agora"
        },
        "sectionTitle": {
            "priorityUnread": "Atualizações importantes não lidas",
            "all": "Todas as notificações"
        },
        "modalTitle": "Você tem %{count} atualizações importantes",
        "priorityModalTitle": {
            "defaultTitle": "Ver todas as atualizações"
        }
    },
    "createEntity": {
        "cancel": {
            "title": "Cancelar %{actionType} de %{entity}",
            "message": "Tem certeza que deseja cancelar %{actionType} de %{entity}?"
        },
        "action": {
            "creating": "criando",
            "editing": "editando"
        },
        "type": {
            "team": "equipe",
            "community": "comunidade",
            "event": "evento",
            "challenge": "desafio",
            "goal": "meta"
        }
    },
    "publicVisibilitySwitch": {
        "modalTitle": {
            "public": "Tornar público?",
            "private": "Tornar privado?"
        },
        "modalSubtitle": {
            "public": "Tornar este(a) %{entityType} público(a) permitirá que todos possam encontrar e participar. Tem certeza que deseja tornar este(a) %{entityType} público(a)?",
            "private": "Tornar este %{entityType} privado(a) não permitirá que as pessoas encontrem e participem. Tem certeza que deseja tornar este(a) %{entityType} privado(a)?"
        },
        "footerButton": {
            "makePublic": "Sim, tornar público",
            "makePrivate": "Sim, tornar privado",
            "keepPrivate": "Manter privado",
            "keepPublic": "Manter público"
        },
        "label": {
            "title": "Tornar este(a) %{entityType} público(a)",
            "subtitle": "Todos podem ver e participar"
        }
    },
    "imageUploader": {
        "changeImageButton": "Alterar imagem"
    },
    "copyright": "Copyright © Sprout 2019",
    "samsunghealth_not_available": "Não foi possível conectar-se ao Samsung Health. No aplicativo Saúde, em Permissões de Dados, certifique-se de ter, no mínimo, permissão habilitada para as etapas e pelo menos 1 etapa rastreada.",
    "rewardsHowDoIEarn": "Como faço para ganhar %{currencyName}?",
    "unlockAchievements": "Desbloquear conquistas",
    "unlockAchievementsDescription": "Rastreie atividades, ganhe %{pointsName}, desbloqueie níveis e ganhe mais %{currencyName}. Toque em cada conquista para ver o que você precisa fazer.",
    "myDay": "Meu dia",
    "myGoalsChallengesTasks": "Minhas metas, desafios e tarefas",
    "yourGoalsChallenges": "Suas metas e desafios",
    "mySocialStream": "Postagens da comunidade",
    "viewAllAchievements": "Ver todas as conquistas",
    "viewAllBonusChallenges": "Ver todos os desafios bônus",
    "newVersionOfAppAvailable": "Nova versão disponível! Recarregue esta página",
    "noBonusChallengesToDisplay": "Não há desafios bônus disponíveis no momento.",
    "bonusChallenges": "Desafios bônus",
    "reloadAppVersion": "Recarregar",
    "appname": "Sprout",
    "cancel_tracking_confirmation": "Tem certeza que deseja remover o rastreamento de %{activity_name}?",
    "activity_tracker_instruction_header": "Toque em um dia para rastrear as atividades daquele dia ou veja o que já foi rastreado.",
    "alertDashboardFunctionalityToBeAdded": "texto será adicionado aqui para explicar o que é o período de rastreamento, semelhante a como é feito pelos programas de fidelidade de companhias aéreas, em que os usuários precisam continuar acumulando “milhas” em um ano civil para obter status para o próximo ano.",
    "noNumberEntered": "Insira a quantidade de atividade",
    "feed": "Stream",
    "home": "Página inicial",
    "challenges": "Desafios",
    "explore": "Explorar",
    "rewards": "Recompensas",
    "reward": "recompensa",
    "balance": "Meu saldo de recompensas de %{programName}",
    "profile": "Perfil",
    "loading": "Carregando...",
    "me": "Eu",
    "back": "Voltar",
    "next": "Avançar",
    "skip": "Pular",
    "signup": "Registrar-se",
    "signin": "Entrar",
    "signin_maintitle": "Sprout",
    "signin_subtitle": "",
    "signinto": "Entrar no Live Better",
    "signup_with_medibank": "Cadastrar-se como membro do Medibank",
    "signup_with_facebook": "Registrar-se com Facebook",
    "signup_with_google": "Registrar-se com Google",
    "signup_with_email": "Registrar-se com e-mail",
    "signin_with_medibank": "Entrar usando Meu Medibank",
    "signin_with_facebook": "Entrar com Facebook",
    "signin_with_google": "Entrar com Google",
    "signin_with_email": "Entrar com e-mail",
    "signup_heading": "Criar conta",
    "not_a_medibank_member": "Não é membro do Medibank?",
    "keep_me_signed_in": "Mantenha-me conectado",
    "forgotpassword": "Esqueceu sua senha?",
    "emailaddress": "Endereço de e-mail",
    "password": "Senha",
    "enterEmailAddress": "Insira seu endereço de email",
    "enterYourPassword": "Insira sua senha",
    "password_for_error": "senha",
    "reset_password": "Redefinir senha",
    "passwordResetSuccess": "Senha redefinida",
    "passwordResetEmailSent": "Se tivermos um e-mail correspondente em nosso sistema, as instruções de redefinição de senha foram enviadas para você.",
    "loginerror": "Ocorreu um erro ao fazer login:",
    "logincancelled": "Login cancelado",
    "part_of_corporate_program": "Você está se inscrevendo em um programa corporativo?",
    "continue_here": "Continue aqui",
    "program_name": "Nome do programa",
    "error_provide_program_name": "Forneça um nome de programa.",
    "program_not_found": "Programa não encontrado",
    "registration_field_email": "E-mail",
    "employeeId": "ID do Empregado",
    "registration_field_firstName": "Nome",
    "registration_field_lastName": "Sobrenome",
    "no_first_name": "Sem nome",
    "no_last_name": "Sem sobrenome",
    "registration_field_password": "Nova senha",
    "no_disclaimer_available": "Ops, ocorreu um problema... Não foi possível recuperar os termos e condições de sua organização. Tente se registrar novamente mais tarde. ",
    "registration_account_not_registered": "Parece que você ainda não verificou seu endereço de e-mail. Quer que o e-mail seja reenviado?",
    "resend_verification_email": "Verificação de e-mail",
    "resend_verification_email_successful": "Reenviamos seu e-mail de verificação.",
    "resend_verification_email_unsuccessful": "Ops, ocorreu um problema... não foi possível reenviar o e-mail de verificação. Tente novamente.",
    "not_supported": "Esta postagem não pode ser exibida no momento. Tente novamente mais tarde.",
    "policyAgreeError": "Para continuar, concorde com os Termos de Serviço e a Política de Privacidade.",
    "challenge_completion_bonus": "Bônus de conclusão",
    "me_tabs": {
        "activity": "Atividade",
        "bookmarks": "Favoritos"
    },
    "health_tab": {
        "my_health_score": "Sua pontuação de bem-estar",
        "overall_health_score_description": "Sua pontuação de bem-estar é",
        "health_score_explanation": "Sua pontuação de bem-estar é calculada a partir das respostas sobre sua saúde e quão ativo você é. \n\nSua pontuação é atualizada a cada mês com base em seus níveis de atividade. Você pode definir e concluir metas pessoais para melhorar sua pontuação de bem-estar.",
        "health_score_calculation_failed_onboarding": "Algo deu errado e não conseguimos recuperar sua pontuação de bem-estar. Você pode prosseguir por agora e assim que o problema for resolvido, nós atualizaremos sua pontuação."
    },
    "track_activity": "Rastrear atividade",
    "track_an_activity": "Rastrear uma atividade",
    "track": "Rastrear",
    "unable_to_track": "Não foi possível rastrear",
    "enter_before_track": "Insira a quantidade de atividades para rastrear",
    "what_to_share": "Que tipo de atualização você gostaria de compartilhar?",
    "remove": "Remover",
    "activity_tracking_description": "Quantos(as) %{units} você gostaria de rastrear?",
    "excessive_submission": "Uau! Você está prestes a rastrear mais de 2000 %{customPoints} por %{activity_name}. Você pode querer se certificar de que está correto antes de enviar.",
    "on": "em",
    "in": "in",
    "from": "de",
    "at": "em",
    "no_activities": "Nenhuma atividade corresponde à sua pesquisa.",
    "activity_tracking_desc": "Você precisa adicionar um número para continuar. Toque no X no canto esquerdo para cancelar.",
    "activity_tracking_desc2": "Toque em qualquer lugar na atividade para editar, toque em + para rastrear rapidamente a meta",
    "vital_stats_title": "Sobre você",
    "invalid_numeric_response": "Inválido",
    "invalid_numeric_response_range": "Este número deve estar entre %{minimum} e %{maximum}",
    "search_placeholder": "Pesquisar na biblioteca...",
    "search_activities": "Pesquisar atividades",
    "searching": "Pesquisando...",
    "searchEmpty": "Nenhuma correspondência encontrada",
    "vital_stats_description": "Conte-nos um pouco sobre você",
    "health_survey_questions": "Perguntas da pesquisa de bem-estar",
    "health_survey_title": "Preencha a pesquisa de bem-estar",
    "health_survey_results": "Resultados da pesquisa de bem-estar",
    "health_survey_card_desc": "Responda à pesquisa para obter um instantâneo do seu bem-estar e definir metas personalizadas.",
    "apps_devices_title": "Vincule aplicativos e dispositivos",
    "apps_devices_card_desc": "Sincronize seus aplicativos e dispositivos para ganhar %{customPoints} facilmente.",
    "interests_title": "Interesses",
    "interests_card_desc": "Conte-nos sobre seus interesses. Isso nos ajudará a recomendar metas e comunidades que podem ser interessantes para você.",
    "interests_screen_desc": "O que desperta seu interesse?",
    "health_obj_title": "Objetivos de bem-estar",
    "health_obj_card_desc": "Achamos que é hora de definir algumas metas. Assim que conhecermos seus objetivos, poderemos fazer recomendações melhores para você. Não se preocupe, se mudar de ideia, você pode alterar seu perfil facilmente mais tarde. ",
    "health_obj_screen_desc": "Que áreas você gostaria de trabalhar?",
    "my_heatlh_obj": "Meus objetivos de bem-estar",
    "health_topic_title": "Tópicos de bem-estar",
    "health_topic_card_desc": "Personalize sua experiência especificando seus tópicos de bem-estar.",
    "health_topic_screen_desc": "Sobre o que você está interessado em aprender?",
    "multi_select_check_error": "Selecione pelo menos 1 opção para continuar",
    "my_health_topics": "Meus tópicos de bem-estar",
    "build_your_profile": "Construa seu perfil",
    "personalize_title": "Personalize",
    "personalize_desc": "Personalize sua experiência respondendo a algumas perguntas rápidas.",
    "set_goals_title": "Ver metas recomendadas",
    "set_goals_desc": "Defina metas personalizadas para iniciar seu caminho para uma saúde melhor.",
    "set_this_goal": "Definir esta meta",
    "goal_set": "Meta definida",
    "required": "Obrigatório",
    "apps_devices_description": "Conecte-se a uma plataforma de condicionamento físico para ganhar mais %{customPoints} automaticamente.",
    "connected": "Conectado",
    "num_connected": "(%{numDevices} conectados)",
    "available": "Disponível",
    "inProgress": "Em andamento...",
    "time_a_m": "am",
    "time_p_m": "pm",
    "last_synced": "Última sincronização",
    "last_synced_lc": "última sincronização",
    "no_connected_devices": "Nenhum dispositivo conectado",
    "apps_devices_confirm_disconnect": "Tem certeza que deseja desconectar",
    "button_delete": "Excluir",
    "button_disconnect": "Desconectar",
    "button_cancel": "Cancelar",
    "button_dismiss": "Dispensar",
    "ok": "OK",
    "waist_helper_text": "A medida da cintura deve ser feita abaixo das costelas, geralmente no nível do umbigo e em pé. Se não tiver certeza, use o tamanho de seu jeans.",
    "apps_devices_manage": "Gerenciar meus aplicativos e dispositivos",
    "my_apps_devices": "Meus aplicativos e dispositivos",
    "completeRegistration": "Concluir registro",
    "havingTrouble": "Está tendo problemas?",
    "contactUs": "Entre em contato com support@sproutatwork.com para obter assistência",
    "done": "Concluído",
    "brand": "Sprout",
    "cannotTrackTitle": "Não foi possível rastrear atividade",
    "cannotTrackPrior": "Mais devagar. As atividades só podem ser rastreadas após a data de início.",
    "cannotTrackFuture": "Não tão rápido. As atividades podem ser rastreadas apenas até o dia atual.",
    "cannotTrack": "As atividades não podem ser rastreadas antes da data de início ou em um dia no futuro.",
    "disclaimer": "Aviso legal",
    "acceptTerms": "Eu aceito os termos e condições",
    "verificationEmailTitle": "Verifique seu e-mail",
    "email_not_yet_verified": "Parece que você ainda não verificou seu endereço de e-mail. ",
    "email_successfully_verified_title": "Bem-vindo",
    "email_successfully_verified": "Você verificou seu e-mail com sucesso",
    "pleaseVerifyEmailMessage1": "Você precisa verificar seu endereço de e-mail para continuar.",
    "pleaseVerifyEmailMessage2": "Siga as instruções enviadas para:",
    "supportEmail": "support@sproutatwork.com",
    "resendEmail": "Reenviar e-mail",
    "restart": "Voltar ao login",
    "firstName": "Nome",
    "firstNamePlaceholder": "Seu nome",
    "lastName": "Sobrenome",
    "lastNamePlaceholder": "Seu sobrenome",
    "email": "E-mail",
    "emailPlaceholder": "Seu endereço de e-mail",
    "employeId": "ID do Empregado",
    "employeIdPlaceholder": "ID de empregado da empresa",
    "passwordPlaceholder": "Nova senha",
    "datePickerTitle": "Selecione a sua data de nascimento",
    "datePickerConfirm": "Confirmar",
    "datePickerCancel": "Cancelar",
    "termsOfUsePrivacyPreLinks": "Eu concordo com",
    "sendMePromoCommunications": "Envie-me comunicações promocionais",
    "sendMePromoCommunicationsFromPartners": "Envie-me comunicações promocionais de parceiros",
    "termsOfService": "Termos de serviço",
    "legal": "Legal",
    "privacyPolicy": "Política de privacidade",
    "and": "e",
    "programDomainLabel": "Nome do programa",
    "programDomainPlaceholder": "Nome do programa",
    "findProgramName": "Encontrar o nome do meu programa",
    "findProgramNameButton": "Encontrar nome do programa",
    "findProgramNameTitle": "Encontrar o nome do meu programa",
    "findProgramNameDescription": "Endereço de e-mail da empresa",
    "findProgramNamePlaceholder": "Endereço de e-mail",
    "findProgramSuccessMessage": "Os resultados da pesquisa de nome do programa foram enviados a você por e-mail.",
    "findProgramSuccessTitle": "Nome do programa",
    "findProgramErrorTitle": "Nome do programa",
    "findProgramErrorMessage": "Ops, ocorreu um problema... Encontramos um erro ao tentar recuperar o nome do seu programa. Tente novamente.",
    "countryLabel": "Selecionar país",
    "countryName": "País",
    "regionLabel": "Selecionar região",
    "regionName": "Região",
    "cityLabel": "Selecionar cidade",
    "cityName": "Cidade",
    "locationWorkLabel": "Selecionar localização",
    "locationWorkName": "Localização",
    "locationLabel": "Selecionar localização",
    "locationName": "Localização",
    "departmentLabel": "Selecionar departamento",
    "departmentName": "Departamento",
    "no_department": "Nenhum departamento",
    "enterPIN": "Digite o PIN da sua empresa",
    "verifyEmailTitle": "Verificação de e-mail",
    "verifyEmailMsg": "Parece que você ainda não verificou seu endereço de e-mail",
    "resendEmailTitle": "Verificação de e-mail",
    "resendEmailMsg": "Reenviado para %{userEmail}",
    "select_date": "Selecione uma data",
    "changePasswordTitle": "Alterar senha",
    "currentPassword": "Senha atual",
    "newPassword": "Nova senha",
    "confirmNewPassword": "Confirme a nova senha",
    "passwordChangeError": {
        "currentPasswordMissing": "Digite sua senha atual",
        "newPasswordMissing": "Digite sua nova senha",
        "confirmPasswordMissing": "Confirme sua nova senha",
        "passwordsMatch": "As senhas não coincidem",
        "passwordIncorrect": "Senha incorreta. Tente novamente."
    },
    "settings": "Configurações",
    "signOut": "Sair",
    "updateApp": "Atualizar aplicativo",
    "updateAppRight": "Atual: %{version}",
    "appleStoreUrlSprout": "https:\/\/itunes.apple.com\/us\/app\/sprout-at-work\/id904741273",
    "playStoreUrlSprout": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.sproutmobileapp",
    "appleStoreUrlLiveBetter": "https:\/\/itunes.apple.com\/us\/app\/live-better\/id1289314646",
    "playStoreUrlLiveBetter": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.livebetter",
    "appleStoreUrlTelus": "https:\/\/apps.apple.com\/app\/telus-health-wellbeing\/id1627569346",
    "playStoreUrlTelus": "https:\/\/play.google.com\/store\/apps\/details?id=com.telus.health.wellbeing",
    "appleStoreUrlUPnGO": "https:\/\/itunes.apple.com\/us\/app\/upngo-with-participaction\/id1079958142",
    "playStoreUrlUPnGO": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.upngo",
    "getHelp": "Obter ajuda",
    "feedback": "Feedback",
    "feedback_success_title": "Feedback enviado",
    "feedback_success_msg": "Obrigado por enviar seu feedback, nós valorizamos isso!",
    "feedback_failure_title": "Erro",
    "feedback_failure_msg": "Que chato... Ocorreu um erro ao enviar seu feedback. Tente novamente.",
    "submit": "Enviar",
    "feedback_char_limit": "Você excedeu o limite de caracteres.",
    "feedback_char_limit_toast_title": "Mensagem muito longa",
    "feedback_char_limit_toast_msg": "Sua mensagem excede o limite máximo de 2000 caracteres.",
    "feedback_char_length_msg_1": "Você digitou",
    "feedback_char_length_msg_2": "\/2000 caracteres.",
    "feedback_empty_toast_title": "Mensagem vazia",
    "feedback_empty_toast_msg": "Parece que você ainda não digitou nada. Digite uma mensagem antes de enviar.",
    "feedback_email_message": "Mensagem:",
    "feedback_email_user_id": ", ID de usuário:",
    "feedback_email_device": ", Dispositivo:",
    "feedback_email_os_version": ", Versão do sistema operacional:",
    "feedback_email_app_version": ", Versão do aplicativo:",
    "savingUserToast": {
        "success": {
            "title": "Salvar alterações",
            "message": "Alterações de perfil salvas"
        },
        "danger": {
            "title": "Erro encontrado",
            "message": "Ops... Encontramos um erro ao tentar salvar suas alterações. Tente novamente."
        }
    },
    "edit_profile_user_error_msg": "Revise os erros antes de tentar salvar suas alterações",
    "edit_profile_location_error": "Você precisa especificar sua localização",
    "edit_profile_department_error": "Você precisa especificar seu departamento",
    "edit_profile_unspecified_value": "Você precisa especificar um valor",
    "edit_profile_value_too_low": "O valor deve ser maior que",
    "edit_profile_value_too_high": "O valor deve ser menor que",
    "choose_gender": "Selecione o gênero",
    "activity_tracked_successfuly": "Sua atividade está sendo rastreada",
    "multi_activity_tracked_successfully": "Suas atividades estão sendo rastreadas",
    "no_activities_tracked": "Nenhuma atividade rastreada",
    "track_activity_to_submit": "Escolha uma data no calendário para rastrear uma atividade",
    "last_day": "Último(a)",
    "days_remaining": "dias restantes",
    "day_remaining": "dia restante",
    "days_remaining_this_week": "dias restantes esta semana",
    "day_remaining_this_week": "dia restante esta semana",
    "days_remaining_this_month": "dias restantes este mês",
    "day_remaining_this_month": "dia restante este mês",
    "earned_today": "Ganho hoje",
    "earned_this_week": "Ganho esta semana",
    "earned_this_month": "Ganho este mês",
    "earned_in_total": "Ganho no total",
    "goal_completed": "Meta concluída,",
    "see_results": "ver resultados",
    "pts": "%{customPoints}",
    "of": "de",
    "daily_goal": "Meta diária",
    "weekly_goal": "Meta semanal",
    "monthly_goal": "Meta mensal",
    "total_goal": "Meta total",
    "weeks": "semanas",
    "today": "Hoje",
    "this_week": "Esta semana",
    "this_month": "Este mês",
    "overall": "Geral",
    "level": "Nível",
    "days_remaining_in_period": "%{remainingDays} dias restantes",
    "days_left_in_period": "%{remainingDays} dias restantes para rastrear",
    "pointsToLevel": "Progresso em direção a %{levelName}",
    "levelCompleted": "%{levelName} concluído",
    "keepTrackingUntil": "Continuar rastreando até",
    "activityLevelTitle": "Meu nível de atividade",
    "activityLevelDescription": "Quanto tempo você passa sendo pelo menos moderadamente ativo - isto é, quando você está trabalhando duro o suficiente para aumentar sua frequência cardíaca e suar - em uma semana normal? ",
    "activityLevelUnder60": "Menos de 60 minutos",
    "activityLevelUnder150": "De 60 a 150 minutos",
    "activityLevelOver150": "Mais de 150 minutos",
    "gender_male": "Masculino",
    "gender_female": "Feminino",
    "gender_rather_not_say": "Prefiro não dizer",
    "date_of_birth": "Data de nascimento",
    "height": "Altura",
    "Height": "Altura",
    "weight": "Peso",
    "waistCircumference": "Circunferência da cintura",
    "bloodPressureHg": "Pressão arterial sistólica",
    "bloodPressureMm": "Pressão arterial diastólica",
    "bloodCholesterol": "Colesterol total no sangue",
    "ldl": "Lipoproteína de baixa densidade (LDL)",
    "hdl": "Lipoproteína de alta densidade (HDL)",
    "restingHeartRate": "Frequência cardíaca em repouso",
    "percentageBodyFat": "Percentual de gordura corporal",
    "hipCircumference": "Circunferência do quadril",
    "bloodGlucose": "Glicose no sangue",
    "triglycerides": "Triglicerídeos",
    "error_401_signed_out_message": "Sua sessão expirou. Faça login novamente.",
    "first_name": "Nome",
    "last_name": "Sobrenome",
    "preferred_name": "Nome preferido",
    "notifications": "Notificações",
    "notificationsMarkAllReadButton": "Marcar todas as notificações como lidas",
    "notificationsSettingsButton": "Configurações",
    "notificationsSettingsTitle": "Notificações e e-mails",
    "notificationEmptyMessage": "Você está em dia com suas notificações",
    "priorityModalTitle": "Minhas notificações prioritárias",
    "remindMeLater": "Lembre-me mais tarde",
    "priorityAdminTitle": "Notificação do seu administrador",
    "markAsRead": "Marcar como lida",
    "expand": "Toque para expandir",
    "collapse": "Toque para recolher",
    "takePhoto": "Tirar uma nova foto",
    "choosePhoto": "Escolha uma foto",
    "deletePhoto": "Excluir foto",
    "profileImageChangeErrorTitle": "Erro encontrado",
    "profileImageChangeErrorMessage": "Ops... Algo deu errado ao editar sua foto. Tente novamente.",
    "editProfile": "Editar Perfil",
    "postButton": "Publicar",
    "shareYourDayName": "O que você está fazendo?",
    "greeting": "Olá, %{firstNameDisplay}!",
    "shareAnUpdate": "O que você está fazendo?",
    "shareYourDaySubtitle": "O que você está fazendo?",
    "shareAPost": "Compartilhar uma postagem",
    "postVisibleTo": "Visível para",
    "link": "Link",
    "photo": "Foto",
    "insertLink": "Adicione um link para sua postagem",
    "save": "Salvar",
    "sampleLink": "http:\/\/sample.com",
    "shareErrorText": "Você precisa adicionar conteúdo à sua postagem antes de enviar.",
    "generalErrorTitle": "Postagem vazia",
    "generalSuccessTitle": "Sucesso",
    "simplePlaceholder": "O que você está fazendo?",
    "likesCountLabel": "Curtir",
    "likesReceivedLabel": "Curtida recebida",
    "commentsCountLabel": "Comentários",
    "commentsCountLabelSingular": "Comentar",
    "likeButton": "Curtir",
    "commentButton": "Comentar",
    "seePreviousComments": "Ver comentários anteriores",
    "addCommentPlaceholder": "Adicione um comentário",
    "postCommentButton": "Publicar",
    "seeMoreLongComment": "Ver mais",
    "activityPoints": "%{customPoints}",
    "activityLog": "Registro de atividade",
    "discardPost": "Descartar",
    "discardPostMessage": "Tem certeza de que deseja descartar sua postagem?",
    "stream_filter_title": "Stream",
    "stream_filter_screen_desc": "Selecione as postagens que deseja visualizar no stream",
    "stream_filter_selection": "Exibindo:",
    "moderate": "Marcar como impróprio",
    "moderateDescription": "Marcar este item como impróprio irá removê-lo e um administrador será notificado.",
    "editPost": "Editar postagem",
    "deletePost": "Excluir postagem",
    "deleteComment": "Excluir comentário",
    "editComment": "Editar comentário",
    "visibleOnlyToMe": "Visível apenas para mim",
    "joinEvent": "RSVP para o evento",
    "joinEventDetail": "Participar do evento",
    "joinedEvent": "Eu vou",
    "joiningEventToast": {
        "success": {
            "title": "%{eventName}",
            "messageName": "Você se juntou ao evento",
            "message": "Você se juntou a este evento com sucesso"
        }
    },
    "joinChallenge": "Entrar no desafio",
    "viewChallenge": "Ver desafio",
    "joinedChallenge": "Entrou no desafio",
    "joinCommunity": "Entrar na comunidade",
    "joinedCommunity": "Entrou na comunidade",
    "joinProgress": "Entrando",
    "joinSuccess": "Entrou",
    "invitePeopleToCommunity": "Convide pessoas para a comunidade",
    "numberOfMembers": "%{num} membros",
    "joinToView": "Participe desta comunidade para ver e postar para outros membros",
    "numberOfAttendees": "%{num} participante(s)",
    "numberOfParticipants": "%{num} participante(s)",
    "numberOfMembersWithUser": "Você e %{num} outros membro(s)",
    "numberOfAttendeesWithUser": "Você e %{num} outros participante(s)",
    "numberOfParticipantsWithUser": "Você e %{num} outros participante(s)",
    "communityMembers": "%{numberOfMembers} membro(s)",
    "communityEvents": "%{numberOfEvents} próximo(s) evento(s)",
    "myEvents": "Meus eventos",
    "seeAll": "Ver tudo",
    "noUpcomingEvents": "Nenhum evento futuro. Vamos nos juntar a um!",
    "myCommunities": "Minhas comunidades",
    "invitedCommunities": "Convidado",
    "invitationSendingMessage": "Enviando convites...",
    "invitationReceivedMessage": "convidou você a juntar-se a",
    "invitationMessage": "Adoraríamos ter você em nossa comunidade!",
    "recommendedCommunities": "Recomendado para você",
    "leaveCommunity": "Sair desta comunidade",
    "leaveTeam": "Tem certeza que deseja sair da equipe",
    "leaveTeamLastMember": "neste desafio? Como último membro da equipe, deixar o desafio excluirá a equipe.",
    "leaveTeamChallenge": "neste desafio?",
    "Oops": "Ops, algo deu errado",
    "editCommunity": "Editar comunidade",
    "deleteCommunity": "Excluir esta comunidade",
    "leaveCommunityDescription": "Tem certeza que deseja sair desta comunidade?",
    "inviteToCommunity": "Convidar para a comunidade",
    "inviteByMembers": "Convidar por nome",
    "inviteByEmail": "Convidar por e-mail",
    "select_person": "Selecione pelo menos uma pessoa para convidar",
    "no_users_found": "Hmmm... parece que não conseguimos encontrar ninguém com esse nome.",
    "promptJoinCommunities": "Parece que você ainda não entrou em nenhuma comunidade. Junte-se a comunidades para interagir com outras pessoas e compartilhar sua jornada.",
    "exploreCommunities": "Explore comunidades",
    "sendInviteByMembers": "Convidar %{num} pessoas",
    "sendInviteByEmail": "Enviar convite por e-mail",
    "createNewCommunity": "Criar uma nova comunidade",
    "createCommunity": "Criar comunidade",
    "uploadCover": "Adicione uma foto",
    "cover": "Cobertura",
    "nameOfCommunity": "Nome da comunidade",
    "whatCommunityAbout": "Sobre o que é esta comunidade?",
    "companyMembersOnly": "Membros da empresa apenas",
    "viewAllButton": "Ver tudo",
    "communities": "Comunidades",
    "contentLibrary": "Biblioteca",
    "events": "Eventos",
    "past_events": "Eventos passados",
    "invitationCommunity": "comunidade",
    "searchPeople": "Pesquisar pessoas",
    "enterEmail": "Insira o e-mail",
    "personalMessageToNewInvitees": "Mensagem pessoal para novos convidados",
    "dangerToastTitle": "Erro",
    "dangerToastMessage": "Hmmm... Algo deu errado. Tente novamente.",
    "successToastTitle": "Sucesso",
    "successToastMessage": "Ação concluída",
    "joiningToast": {
        "success": {
            "message": "Você entrou"
        }
    },
    "deletingCommentToast": {
        "success": {
            "message": "Comentário excluído"
        }
    },
    "moderatingCommentToast": {
        "success": {
            "message": "Comentário marcado como impróprio"
        }
    },
    "editingCommentToast": {
        "success": {
            "message": "Comentário atualizado"
        }
    },
    "gettingLikesToast": {
        "success": {
            "message": "Comentário atualizado"
        }
    },
    "updatingAvatarToast": {
        "success": {
            "message": "Foto do perfil atualizada"
        }
    },
    "deletingAvatarAvatarToast": {
        "success": {
            "message": "Foto excluída"
        }
    },
    "creatingStreamToast": {
        "success": {
            "title": "Postar no stream",
            "message": "Sua postagem foi criada"
        }
    },
    "editingStreamToast": {
        "success": {
            "title": "Editar postagem",
            "message": "Sua postagem foi editada"
        }
    },
    "deletingPostToast": {
        "success": {
            "title": "Excluir postagem",
            "message": "Sua postagem foi excluída"
        }
    },
    "moderatingPostToast": {
        "success": {
            "title": "Marcar como impróprio",
            "message": "Postagem marcada como imprópria"
        }
    },
    "markingAllNotificationsToast": {
        "success": {
            "title": "Marcar como lida",
            "message": "Todas as notificações marcadas como lidas"
        },
        "info": {
            "title": "Marcar como lida",
            "message": "Todas as notificações já foram marcadas como lidas."
        },
        "danger": {
            "title": "Marcar como lida"
        }
    },
    "markingNotificationToast": {
        "danger": {
            "title": "Não é possível marcar a notificação como lida"
        }
    },
    "changePasswordToast": {
        "success": {
            "title": "Senha atualizada",
            "message": "Faça login com sua nova senha"
        },
        "danger": {
            "title": "Atualizar senha",
            "message": "Ops Algo deu errado quando tentamos atualizar sua senha. Tente novamente."
        }
    },
    "joining": {
        "success": {
            "message": "Você se juntou a %{name}"
        }
    },
    "invitingUsersToast": {
        "success": {
            "title": "Convites",
            "message": "O(s) convite(s) foram enviados"
        }
    },
    "creatingCommunityToast": {
        "success": {
            "title": "Criar comunidade",
            "message": "Sua nova comunidade foi criada"
        }
    },
    "restartingCustomGoalToast": {
        "success": {
            "message": "Sua meta foi reiniciada"
        },
        "danger": {
            "message": "Não foi possível reiniciar meta"
        }
    },
    "quit": "Sair",
    "wellbeing_survey_completed": "Pesquisa de bem-estar concluída",
    "wellbeing_survey_completed_message": "Obrigado por completar a pesquisa. Esperamos que isso tenha ajudado você a obter alguns insights sobre o seu bem-estar.",
    "update_wellbeing_score": "Atualizar minhas respostas da pesquisa",
    "get_wellbeing_score": "Obtenha sua pontuação de bem-estar",
    "stats": "Estatísticas",
    "my_wellbeing_score": "Minha pontuação de bem-estar",
    "see_details": "Ver detalhes",
    "how_score_calculated": "Como minha pontuação é calculada?",
    "contentTitle": "Biblioteca",
    "promoted": "Em Destaque",
    "recommended": "Recomendado",
    "recommendedForMe": "Recomendado para mim",
    "recent": "Adicionado recentemente",
    "view": "Ver",
    "added": "Adicionado",
    "more": "mais",
    "openLibrary": "Leve-me à biblioteca",
    "readToEarn": "Leia para ganhar",
    "readArticle": "Abrir link",
    "see_more": "Ver mais (%{num})",
    "see_more_activities": "mais %{num}",
    "my_achievements": "Minhas conquistas",
    "achievements": "Conquistas",
    "achievement_earned_date": "Ganhou em: %{date}",
    "achievement_start_date": "Iniciou em: %{date}",
    "achievement_end_date": "Termina em: %{date}",
    "achievement_earned": "Ganhou",
    "achievement_start": "Começa em",
    "achievement_end": "Termina em",
    "achievement_earned_times": "%{num} vezes",
    "achievement_earned_time": "%{num} vez",
    "in_progress": "Em andamento",
    "date_earned": "Data em que ganhou",
    "earned": "Ganhou",
    "past_dates_earned_heading": "Datas anteriores em que ganhou",
    "all": "Tudo",
    "eat": "Alimentação",
    "move": "Movimento",
    "feel": "Sensações",
    "profile_completion": "Preenchimento do perfil: %{percent}%",
    "complete_my_profile": "Complete seu perfil",
    "do_following_tasks": "Faça a(s) seguinte(s) %{num} tarefa(s) para completar seu perfil.",
    "improve_my_score": "Melhore sua pontuação",
    "see_which_goals": "Verifique as metas que definiu para comer, movimentar-se e sentir-se melhor.",
    "havent_set_goal": "Você ainda não definiu uma meta.",
    "set_a_goal": "Defina uma meta",
    "set_another_goal": "Defina outra meta",
    "set_another_goal_here": "Defina outra meta aqui.",
    "my_recently_tracked_activities": "Minhas atividades recentes",
    "a_few_seconds_ago": "alguns segundos atrás",
    "a_day_ago": "um dia atrás",
    "yesterday": "Ontem",
    "earn": "Ganhe",
    "delete_activity_confirmation": "Tem certeza que deseja remover esta atividade?",
    "delete_activity_title": "Remover %{measurement} de %{activity_name}?",
    "reached_daily_goal": "Você atingiu sua meta hoje. Bom trabalho!",
    "multiple_activity_non_daily_instruction": "Toque em uma linha de atividade para começar a rastrear e ganhar %{customPoints}!",
    "multiple_activity_daily_instruction": "Toque no sinal de mais para rastrear a quantidade de atividade necessária para atingir sua meta. Toque em qualquer outro lugar na linha de atividade para rastrear qualquer quantidade dessa atividade.",
    "only_automatic_activities": "As atividades que contribuem para esta meta só podem ser rastreadas automaticamente",
    "only_automatic_activity": "A atividade que contribui para esta meta só pode ser rastreada automaticamente",
    "earn_pts_and_reach_goal": "Ganhe %{pts} pontos e atinja sua meta rastreando %{qty}",
    "earn_pts_for_every": "Ganhe %{pts} pontos para cada",
    "you_track": "que você rastrear!",
    "you_have_tracked": "Você rastreou %{qty}",
    "so_far": "até agora!",
    "start_goal": "Definir esta meta",
    "about_this_goal": "Sobre esta meta",
    "start_date": "Data de início",
    "end_date": "Data de término",
    "activities": "Atividades",
    "goal": "Meta",
    "instructions": "Instruções",
    "daily": "Diariamente",
    "weekly": "Semanalmente",
    "monthly": "Mensalmente",
    "total": "Total",
    "week": "Semana",
    "day": "Dia",
    "days": "Dias",
    "month": "Mês",
    "months": "Meses",
    "progress": "Progresso",
    "about": "Sobre",
    "days_remaining_to_track": "Você tem %{num} dias para rastrear qualquer atividade perdida",
    "number_days": "%{num} dias",
    "one_day": "1 dia",
    "points_earned_this_week": "Pontos ganhos esta semana",
    "points_earned_year": "Pontos ganhos no ano até hoje",
    "completed": "Concluído",
    "what_you_need_to_do": "O que você precisa fazer",
    "see_all_num": "Ver todos os %{num}",
    "my_week_progress": "Seu progresso semanal",
    "my_day_progress": "Seu progresso diário",
    "my_month_progress": "Seu progresso mensal",
    "my_total_progress": "Seu progresso total",
    "my_overall_progress": "Progresso geral",
    "you_earned": "Você ganhou",
    "of_this_week": "de %{num} esta semana",
    "of_this_day": "de %{num} hoje",
    "of_this_month": "de %{num} este mês",
    "of_this_total": "de %{num} no total",
    "of_this_overall": "de %{num} no geral",
    "remaining_this_week": "restante(s) esta semana",
    "remaining_this_month": "restante(s) este mês",
    "remaining_this_total": "restantes",
    "remaining_this_overall": "restantes no geral",
    "view_history": "Ver histórico",
    "this_goal_is": "Esta meta é",
    "will_run_for": "Vai durar",
    "button_unset_goal": "Desativar meta",
    "button_leave_challenge": "Sair do desafio",
    "leaveChallenge": {
        "menu": "Sair de %{challengeName}"
    },
    "deleteChallenge": {
        "menu": "Excluir %{challengeName}"
    },
    "unsetGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Você desativou esta meta pessoal."
        }
    },
    "leaveChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Você saiu do desafio."
        }
    },
    "activities_tracked": "Atividades rastreadas",
    "recently_tracked_activities": "Atividades rastreadas recentemente",
    "add": "Adicionar",
    "change_before_track": "Parece que você não fez nenhuma alteração. Edite a quantidade de atividade para este dia ou saia sem fazer alterações.",
    "havent_tracked_today": "Parece que você ainda não rastreou nenhuma atividade para este dia. Comece pesquisando uma atividade.",
    "cancel_tracking_quantity": "Cancelar rastreamento de %{quantidade} de %{activity_name}",
    "points": "%{customPoints}",
    "discard_activity_edits_confirmation": "Sair vai descartar as edições em seu histórico de atividades. Tem certeza?",
    "discard_activity_edits_confirmation_date": "Sair vai descartar as edições em seu histórico de atividades para %{date}. Tem certeza?",
    "yes_discard_edits": "Sim, sair e descartar edições",
    "createGoal": {
        "navigatorTitle": "Criar meta pessoal",
        "navigatorSubtitle": "Etapa %{step} de 4"
    },
    "allCommunities": "Tudo",
    "deleteCommunityDescription": "Tem certeza de que deseja excluir esta comunidade?",
    "remaining": "restantes",
    "recommended_goal": "Meta recomendada",
    "pinError": "PIN %{pin} não é válido. Tente novamente.",
    "previousPersonalGoals": "Minhas metas pessoais concluídas",
    "previousGoalsTitle": "Minhas metas anteriores",
    "endedOn": "terminou em",
    "achievedOfGoal": "Você atingiu %{num}% da meta",
    "previousGoalsEmptyMessage": "Você não tem metas anteriores",
    "emptyListDefaultMessage": "Você não tem itens aqui",
    "myCommunitiesEmpty": "Parece que você ainda não entrou em nenhuma comunidade. Junte-se a comunidades para interagir com outras pessoas e compartilhar sua jornada.",
    "discoverMoreCommunities": "Descubra mais comunidades",
    "howLong": "Duração",
    "frequency": "Frequência",
    "discard": "Descartar",
    "description": "Descrição",
    "optional": "opcional",
    "instruction": "Instrução",
    "name": "Nome",
    "create": "Criar",
    "categories": "Categorias",
    "uploadPhoto": "Adicione uma foto",
    "delete_goal": "Excluir este %{name}",
    "delete_goal_confirmation": "Tem certeza de que deseja excluir esta meta?",
    "leave_goal_confirmation": "Tem certeza de que deseja sair deste desafio?",
    "creatingCustomGoalToast": {
        "success": {
            "message": "Sua meta foi criada."
        }
    },
    "defaultSelectMessage": "Selecione uma opção",
    "search": "Pesquisar",
    "inTotal": "no total",
    "State": "Estado",
    "Business unit": "Unidade de negócios",
    "Work location": "Local de trabalho",
    "whenStart": "Quando você quer começar?",
    "every": "todo(a)",
    "acceptChallenge": "Aceitar desafio",
    "activity_history_challenge": "Histórico de atividades para o desafio",
    "havent_tracked_challenge": "Você não rastreou nenhuma atividade para este desafio",
    "earned_lowercase": "ganhou",
    "noone_tracked_yet": "Ninguém rastreou nada ainda. Comece a rastrear para estar na liderança nesta competição!",
    "you": "Você",
    "your_team": "Minha equipe",
    "congrats_first_place": "Parabéns, você está em primeiro lugar! Mantenha o bom trabalho.",
    "leader": "Líder",
    "average": "Média",
    "show_leader": "Mostrar líder",
    "show_me": "Mostrar-me",
    "show_my_team": "Mostrar minha equipe",
    "leaderboard": "Tabela de classificação",
    "my_team": "Minha equipe",
    "remaining_to_track": "restante(s) para rastrear",
    "avg": "média",
    "invite": "Convidar",
    "team_members": "Membros da equipe",
    "daysLeft": "Dias restantes",
    "regionNameLiveBetter": "Estado",
    "locationNameLiveBetter": "Local de trabalho",
    "departmentNameLiveBetter": "Unidade de negócios",
    "regionLabelLiveBetter": "Selecionar estado",
    "locationLabelLiveBetter": "Selecionar local de trabalho",
    "departmentLabelLiveBetter": "Selecionar unidade de negócios",
    "companyLocation": "Local de trabalho",
    "no_location": "Nenhum local",
    "connect": "Conectar",
    "syncing": "Sincronizando",
    "sync": "Sincronizar",
    "havent_tracked_in_a_while": "Nenhuma atividade rastreada recentemente",
    "contact": "Contato",
    "manage": "Gerenciar",
    "creator": "Criador",
    "allow_notifications": "Gerenciar notificações",
    "enable_notifications": "Ativar notificações",
    "appload": "Aguarde um momento enquanto {app_name} é atualizado...",
    "sendResetEmail": "Enviar e-mail de redefinição",
    "min": "Min",
    "max": "Máx.",
    "error_joining_team": "Não foi possível juntar-se à equipe",
    "cannot_add_to_team": "Ops… Algo deu errado quando tentamos adicionar você a esta equipe. Pode ser que a equipe tenha atingido o número máximo de membros ou não exista mais. Caso tenha ocorrido outro erro, tente novamente.",
    "members_needed": "%{num} membros necessários",
    "member_needed": "%{num} membro necessário",
    "spots_left": "%{num} lugares restantes",
    "join": "Entrar",
    "no_teams_create": "No momento, não há equipes para entrar. Por que você não cria uma?",
    "number_teams": "%{num} equipes",
    "youLowercase": "você",
    "joined_challenge_on_team": "Você se juntou a um desafio na equipe %{team_name}.",
    "join_team": "Entrar na equipe",
    "former_members": "Membros antigos",
    "letsGo": "Vamos lá",
    "invite_to_team": "Convidar para a equipe",
    "connectingDeviceToast": {
        "success": {
            "title": "Conecte um aplicativo ou dispositivo",
            "message": "Sucesso! Seu aplicativo ou dispositivo está conectado."
        },
        "danger": {
            "title": "Conecte um aplicativo ou dispositivo",
            "message": "Ops… Ocorreu um problema ao conectar este serviço. Tente novamente."
        }
    },
    "disconnectingDeviceToast": {
        "success": {
            "title": "Desconectar um aplicativo ou dispositivo",
            "message": "Você desconectou %{name} com sucesso."
        },
        "danger": {
            "title": "Desconectar um aplicativo ou dispositivo",
            "message": "Ops… Ocorreu um problema ao desconectar %{name}. Tente novamente."
        }
    },
    "leave_entity_question": "Deixar %{name}?",
    "delete_entity_question": "Excluir %{name}?",
    "leave_team_challenge_confirmation": "Tem certeza que deseja deixar %{name} neste desafio?",
    "leave_last_team_member": "Como último membro da equipe, deixar este desafio excluirá a equipe.",
    "oops_msg": "Ops... Ocorreu um erro ao tentar concluir esta ação. Tente novamente.",
    "has_been_created": "Você se juntou ao desafio na equipe %{name}.",
    "specify_team_name": "Especifique um nome de equipe",
    "invite_members": "Convide membros",
    "upload_photo_no_question": "Adicione uma foto",
    "my_progress": "Meu progresso",
    "rewardsPointsAdditionalInfo": "Ganhe %{reward_currency} para cada nível alcançado a cada %{period}. Seus %{customPoints} e níveis recomeçam a cada %{period} para que você tenha a oportunidade de continuar ganhando %{reward_currency} mesmo que tenha atingido o nível mais alto no último período.",
    "rewardsPointsInfo": "Seus %{customPoints} e progresso são redefinidos a cada %{period}.",
    "departments": "Departamentos",
    "regions": "Regiões",
    "noItemsSelected": "Nenhum item selecionado",
    "pleaseSelectOne": "Selecione pelo menos um item da lista",
    "tracked": "Rastreado",
    "starts": "Começa em",
    "duration": "Duração",
    "bonus": "Bônus",
    "invited_by": "Convidado por",
    "create_team": "Criar uma equipe",
    "discardConfirmation": "Você tem certeza que quer sair?",
    "discardYes": "Sim",
    "discardStay": "Voltar",
    "create_team_toast_title": "Criar equipe",
    "edit_team": "Editar equipe",
    "team_edits_submitted": "Sua equipe foi atualizada.",
    "challenge_ended_still_trackable": "Este %{type} terminou, felizmente você tem %{num} dias restantes para rastrear!",
    "tracking_period_ended": "O período de rastreamento para este %{type} terminou.",
    "unlimited": "Ilimitado(a)",
    "ends_in": "Termina em",
    "challenge_toast": {
        "success": {
            "join": "Sucesso!",
            "message": "Você entrou no desafio com sucesso."
        },
        "danger": {
            "error": "Erro",
            "message": "Algo deu errado. Tente entrar no desafio novamente em alguns instantes."
        }
    },
    "members_to_invite": "Membros para convidar",
    "members_to_remove": "Membros para remover",
    "myChallenges": "Competições",
    "upcoming": "Próximas",
    "myPersonalGoals": "Metas",
    "companyCompetitions": "Competições da empresa",
    "communityCompetitions": "Competições da comunidade",
    "edit_your_team": "Edite sua equipe",
    "emails": "E-mails",
    "CompletedOverall": "Concluído no geral",
    "TotalEarned": "Total ganho",
    "notify_header": "Eu gostaria de ser notificado:",
    "AdditionalBonus": "Bônus adicional",
    "goalEndedNotification": "Meta finalizada, continue se esforçando!",
    "compEndedNotification": "Competição finalizada, continue se esforçando!",
    "congrats_tracking_first": "Parabéns por rastrear sua primeira atividade!",
    "keep_tracking": "Continue rastreando sua atividade para atingir metas e subir de nível.",
    "understanding_tracking": "Entendendo o rastreamento",
    "cannot_track_this_day": "Você não pode rastrear neste dia.",
    "nothing_tracked_this_day": "Você ainda não rastreou este dia.",
    "tracked_something_this_day": "Você rastreou algo para este dia.",
    "reached_goal_this_day": "Você atingiu sua meta para este dia (apenas para metas diárias).",
    "got_it": "Entendi!",
    "notDismissedMultiTitle": "Resumo do desafio",
    "notDismissedMultiSubtitle": "Alguns desafios terminaram. Dê uma olhada em cada um para obter detalhes sobre como você se saiu. ",
    "daySummary": "%{userName}, aqui está um resumo do seu dia até agora",
    "goals": "Metas",
    "competitions": "Competições",
    "totalAccumulated": "Total acumulado",
    "tracking_for_date": "Rastreando para %{date}",
    "activity_tracker_instruction": "Toque para editar ou remover uma atividade rastreada manualmente",
    "ended": "Terminado(a)",
    "notYetAvailableBeta": "Ainda não disponível em beta",
    "suggestedGoal": "Meta sugerida",
    "singleFor": "para",
    "seeLessLongComment": "Ver menos",
    "synced_data": "Dados sincronizados:",
    "doThisLater": "Vou fazer isso mais tarde",
    "inviteUsers": "Convidar outras pessoas para participar",
    "cannotTrackAfterDeadline": "Você está tentando rastrear uma atividade para uma data após o prazo final do desafio.",
    "potentialBonusPoints": {
        "section": {
            "title": "%{potentialBonusPoints} %{customPoints} de bônus estão disponíveis para esta meta!",
            "titleNotCompleted": "Você perdeu %{potentialBonusPoints} %{customPoints} de bônus por %{activitytCompletedPercentage}%.",
            "titleCompleted": "Parabéns! Você ganhou",
            "titleCompletedBold": "%{potentialBonusPoints} %{customPoints} de bônus!",
            "subtitle": "Saiba mais sobre %{customPoints} de bônus"
        },
        "modal": {
            "title": "%{customPoints} de bônus",
            "desc1": "Sabemos que ninguém é perfeito e consegue atingir suas metas 100% do tempo.",
            "desc2": "É por isso que oferecemos %{customPoints} de bônus quando seu progresso geral é de 85% ou mais.",
            "desc3": "Todos os %{customPoints} de bônus são concedidos após a meta ter finalizado e se todo o seu rastreamento for de um aplicativo ou dispositivo conectado, você receberá %{customPoints} de bônus em dobro!",
            "desc4": "Você não receberá %{customPoints} de bônus por metas que deixar antecipadamente."
        },
        "msg": {
            "title": "Esta meta terminou",
            "subtitle": "Meta encerrada em %{goalEndedDate}"
        },
        "msgEnded": {
            "title": "O tempo acabou! Sua meta terminou",
            "subtitle": "Você tem %{daysNum} %{daysOrDay} para rastrear sua atividade."
        }
    },
    "finish": "Terminar",
    "personalGoal": {
        "all_goals": {
            "selected": "Todas as %{maxGoals} metas definidas!",
            "description": "Está do seu agrado? Você pode substituir quaisquer metas se mudar de ideia. Não se preocupe, você poderá desativar sua meta mais tarde.",
            "set": "Todas as metas foram definidas!",
            "action": "Tudo pronto para prosseguir!",
            "error": "Não vamos nos deixar levar! Concentrar-se em no máximo 3 metas estruturadas de cada vez aumentará sua probabilidade de sucesso.",
            "errorHeading": "Definindo metas"
        },
        "set_more": "Todas as %{maxGoals} metas definidas!",
        "select_goal": {
            "heading": "Defina uma meta recomendada ou crie a sua própria"
        },
        "set_more_1": "Você pode definir mais 1 meta ativa"
    },
    "restartPersonalGoal": "Reiniciar meta com novos alvos",
    "delete_challenge_confirmation": "Tem certeza que deseja excluir este desafio?",
    "personal_goal_unit": "meta",
    "personal_goal_units": "metas",
    "day_summary": {
        "steps_taken": "Etapas realizadas",
        "calories_in": "Calorias ingeridas",
        "calories_out": "Calorias queimadas",
        "avg_daily": "média diária",
        "most_earned_daily": "ganho máximo por dia"
    },
    "invitedBy": "Convidado(a) por %{person}",
    "resetPasswordMissingField": "Insira um endereço de e-mail",
    "resetPasswordInvalidValue": "Insira um endereço de e-mail válido",
    "resetPasswordNotFound": "Seu e-mail não pode ser encontrado",
    "resetPasswordNotCompleted": "Sua solicitação não pôde ser concluída",
    "resetGoalInstructions": {
        "start": "Fazer %{quantity} %{units} de %{activity}",
        "additional": ", %{quantity} %{units} de %{activity}",
        "end": "%{frequency} e ganhe %{points} %{customPoints} %{frequency}"
    },
    "goalSet": {
        "one": "Uma meta definida. Ver",
        "two": "Duas metas definidas. Ver",
        "three": "Três metas definidas. Ver",
        "none": "Nenhuma meta definida. Definir metas"
    },
    "searchCommunitiesEmpty": "Nenhuma comunidade encontrada",
    "searchCommunitiesPlaceholder": "Procurar comunidades",
    "updating": "Atualizando...",
    "pts_tracked": "%{activityName} rastreado(a) - %{num} %{customPoints}",
    "improving_wellbeing_score": "Mantenha o bom trabalho, você está no caminho certo para melhorar sua pontuação de bem-estar.",
    "progressHistory": "Histórico de progresso",
    "privateCommunity": "Esta é uma comunidade privada",
    "do_combo_of_activities": "Faça qualquer combinação dos seguintes.",
    "noActivitiesTracked": "Nenhuma atividade rastreada",
    "trackingWithFollowingApps": "Rastreamento com os seguintes aplicativos\/dispositivos",
    "recommendedApps": "Aplicativos\/dispositivos recomendados para este %{challengeType}",
    "collapseWord": "Recolher",
    "started": "Iniciado",
    "ends": "Termina em ",
    "do_activities": "Fazer atividades",
    "rewards_placeholder": "Exemplo de recompensas da loja, marcador de posição. Os usuários verão vários produtos que podem comprar e o custo em %{rewardName}.",
    "personalGoals": {
        "top": {
            "label": "Topo"
        },
        "allGoals": "Todas as metas",
        "seeMoreCard": {
            "heading": "Não vê o que está procurando?",
            "description": "Dê uma olhada em todas as metas recomendadas",
            "button": "Explorar metas"
        }
    },
    "rewardsNotAvailable": "No momento, as recompensas não estão disponíveis nesta versão beta. Quando disponível, você poderá visualizar o catálogo e concluir um resgate.",
    "editProfileProvideRestingHeartRate": "Forneça um valor de frequência cardíaca em repouso válido de pelo menos 40",
    "liveBetterHealthInfo": "Executamos uma série de programas e temos uma variedade de conteúdos de saúde projetados para atender a uma variedade de necessidades de saúde e ajudar você a alcançar uma saúde melhor. Ainda não temos programas para todas as necessidades e condições de saúde - estamos trabalhando nisso! No entanto, se você responder às seguintes perguntas, entraremos em contato com você se identificarmos quaisquer programas ou serviços de saúde dos quais você possa se beneficiar e\/ou enviaremos informações baseadas em evidências que ajudarão você a compreender e gerenciar melhor suas necessidades de saúde. Observe que não usamos essas informações para avaliar a adequação de sua apólice. Se você quiser descobrir o que está incluído em sua cobertura ou tiver alguma dúvida sobre a sua apólice, pode ligar para nossa equipe do Customer Connect no número 132 331.",
    "deleteGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Você excluiu a meta"
        }
    },
    "deleteChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Você excluiu o desafio"
        }
    },
    "invitations": "Convites",
    "learnMorePeriods": "Saiba mais sobre períodos",
    "tracked_by_app_name": "Rastreado por %{app_name}",
    "device_required": {
        "text": "Este(a) %{challengeType} requer um aplicativo ou dispositivo",
        "button": "Conecte um aplicativo ou dispositivo"
    },
    "editingCommunityToast": {
        "success": {
            "title": "Editar comunidade",
            "message": "A comunidade foi editada"
        }
    },
    "competition": "Competição",
    "close": "Fechar",
    "only_automatic_activities_with_device": "As atividades de %{goal_or_competition} são rastreadas automaticamente com seus aplicativos\/dispositivos conectados.",
    "only_automatic_activity_with_device": "A atividade de %{goal_or_competition} é rastreada automaticamente com seus aplicativos\/dispositivos conectados.",
    "deletingCommunityToast": {
        "success": {
            "title": "%{name}",
            "message": "Comunidade excluída"
        }
    },
    "teamSizeMessage": "Sua equipe precisa de pelo menos %{min} pessoas para ganhar %{customPoints} para o desafio.",
    "captain": "Capitão(ã)",
    "inviteOthersToTeam": "Convidar outras pessoas para minha equipe",
    "loadingMetrics": "Conectando-se a fontes para atualizar seu dia...",
    "aboutTeamSize": {
        "title": "Tamanho da equipe",
        "text": "%{min} a %{max}"
    },
    "pointsOverview": "Visão geral de %{customPoints}",
    "deepLinks": {
        "requestCouldNotBeCompleted": "Sua solicitação não pôde ser concluída",
        "error": "Erro"
    },
    "required_lc": "obrigatório",
    "personal": "Detalhes pessoais",
    "biometrics": "Biometria",
    "makeSelection": "Faça uma seleção",
    "ask_question_success_msg": "Obrigado. Responderemos assim que pudermos.",
    "report_issue_success_msg": "Obrigado. Responderemos assim que pudermos.",
    "ask_question_success_title": "Pergunta enviada",
    "report_issue_success_title": "Problema técnico enviado",
    "ask_question_failure_msg": "Que chato... Ocorreu um erro ao enviar sua pergunta. Tente novamente.",
    "report_issue_failure_msg": "Que chato... Ocorreu um erro ao reportar seu problema. Tente novamente.",
    "notTrackedActivities": "Você não rastreou nenhuma atividade para este período",
    "learn": "Aprenda",
    "Balance": "Saldo",
    "details": "Detalhes",
    "Reward": "Recompensa",
    "levelsReset": "Níveis redefinidos em %{remainingDays} dias",
    "redeem": "Resgatar",
    "redeemAt": "Resgatar em %{points}",
    "needPointsToRedeem": "Você precisa de mais %{points} %{rewardName}.",
    "learnEarnMore": "Aprenda como ganhar mais",
    "currency": "SproutBucks",
    "joiningTeamChallengeToast": {
        "success": {
            "title": "Junte-se à equipe",
            "message": "Você se juntou à equipe!"
        },
        "danger": {
            "message": "Encontramos um erro e não conseguimos encontrar a equipe. Pode ser que ela não exista mais."
        }
    },
    "NoMatchingDeepLinkToast": {
        "danger": {
            "title": "Ação não disponível",
            "message": "Seu pedido não pôde ser concluído."
        }
    },
    "transactionLog": "Transações",
    "orderHistory": "Pedidos",
    "pointsAvailableToEarn": "%{points} disponíveis para ganhar",
    "missedYTD": "%{missed} perdidos no ano até agora",
    "rewardsDetails": "Recompensas",
    "successfullyRedeemedItem": "Você resgatou este item com sucesso",
    "orderNumber": "Número do pedido",
    "amountSpent": "Valor gasto",
    "status": "Status",
    "dateRedeemed": "Data do resgate",
    "additionalInformation": "Informações adicionais",
    "shipToAddress": "Enviar para este endereço",
    "pointMissedYearToDate": "%{RewardsCurrencyName} perdidos este ano",
    "pointMissedYearToDateDescription": "Quando você não atinge um nível antes do fim do período, os %{rewardCurrencyName} associados que você poderia ter ganhado são considerados perdidos.",
    "NoLibraryContentToast": {
        "info": {
            "title": "Artigo não encontrado",
            "message": "Não foi possível encontrar o artigo. Ele pode ter sido removido ou não está mais disponível."
        }
    },
    "CommunityNotFoundToast": {
        "danger": {
            "title": "Comunidade não encontrada",
            "message": "Não foi possível encontrar a comunidade. Ela pode ter sido removida ou não está mais disponível."
        }
    },
    "shippingAddress": "Endereço de envio\/cobrança",
    "enterShippingAddress": "Insira o endereço de envio\/cobrança",
    "streetLine": "Linha de endereço %{num}",
    "stateProvince": "Estado\/Província",
    "postcodePostalcodeZip": "Código postal\/CEP\/ZIP",
    "phoneNumber": "Número de telefone",
    "order": "Pedido",
    "redemptionConfirmation": "Confirmação de resgate",
    "edit": "Editar",
    "processing": "Processando",
    "checkIsYouFirst": "Só precisamos verificar se é você",
    "discardSomeGoals": "Você definiu algumas metas. Essas metas serão descartadas se você continuar.",
    "settingGoalsToast": {
        "success": {
            "message": "Suas novas metas foram definidas!"
        }
    },
    "one_team": "1 equipe",
    "noAchievementsToEarnMessage": "Parece que não há mais medalhas para ganhar %{rewardCurrencyName} neste período.",
    "shopRewards": "Recompensas da loja",
    "validateShippingAddressToast": {
        "danger": {
            "title": "Endereço de envio\/cobrança",
            "message": "Preencha todos os campos antes de continuar."
        }
    },
    "viewDetails": "Ver detalhes",
    "potential": "Potencial(is)",
    "missed": "Perdido(s)",
    "rewardsStoreNotAvailable": "A loja de recompensas não está disponível para você no momento.",
    "havent_tracked_in_a_while_date": "Nenhuma atividade rastreada para %{currentDate}",
    "challengeNotFoundToast": {
        "danger": {
            "title": "Desafio não encontrado",
            "message": "Não foi possível encontrar o desafio. Ele pode ter sido removido ou não está mais disponível."
        }
    },
    "shareYourDaySubtitleActivity": "Adicione uma foto ou diga algo sobre esta atividade!",
    "goal_ended": "Meta finalizada",
    "challenge_ended": "Desafio finalizado",
    "day_remaining_to_track": "Você tem 1 dia para rastrear qualquer atividade perdida",
    "challengeGoalCardSubtitleEndDate": "%{challengeOrGoal} terminou em %{endDate}",
    "goalEndedModal": {
        "title": "Colocar as atividades esquecidas em dia",
        "message": "Após a finalização de uma meta ou desafio pessoal, você terá três dias a partir da data do término para rastrear todas as atividades que possa ter esquecido. Após esse período, você não poderá rastrear nenhuma atividade adicional que contribua para a meta ou desafio."
    },
    "summary": "Resumo",
    "placedRank": "Você está em %{rank} de %{total}",
    "rank": {
        "first": "1º",
        "second": "2º",
        "third": "3º",
        "n": "%{rank}º"
    },
    "event_name": "Nome do evento",
    "this_is": "Isto é um(a)  ",
    "location_info": "Localização e informações",
    "what_event": "Sobre o que é este evento",
    "event_is": "Este evento é",
    "start_on": "Começa em:",
    "end_on": "Termina em:",
    "location": "Localização",
    "chooseLeaderboard": "Escolha uma tabela de classificação",
    "filterOneOfFollowing": "Filtre um dos seguintes",
    "showChallengeInstead": "Em vez disso, mostre um desafio",
    "showActivityInstead": "Em vez disso, mostre uma atividade",
    "showAll": "Mostrar tudo",
    "activitiesShowSame": "Atividades: %{activityName}",
    "challengeShowSame": "Desafio: %{challengeName}",
    "chooseTimePeriod": "Escolha um período",
    "youCanFilterOneAtTime": "Um filtro pode ser selecionado por vez",
    "saveHealthTopicsToast": {
        "success": {
            "message": "Tópicos de saúde salvos",
            "title": "Sucesso!"
        },
        "info": {
            "message": "Não foi possível salvar"
        },
        "danger": {
            "title": "Erro!"
        }
    },
    "saveHealthObjectivesToast": {
        "success": {
            "message": "Objetivos de saúde salvos",
            "title": "Sucesso!"
        },
        "info": {
            "message": "Não foi possível salvar"
        },
        "danger": {
            "title": "Erro!"
        }
    },
    "saveInterestGroupsToast": {
        "success": {
            "message": "Interesses salvos",
            "title": "Sucesso!"
        },
        "info": {
            "message": "Não foi possível salvar"
        },
        "danger": {
            "title": "Erro!"
        }
    },
    "edit_event": "Editar evento",
    "leave": "Sair",
    "delete_event": "Excluir evento",
    "no_events": "Nenhum evento",
    "no_events_placeholder": "Atualmente, você não está planejando comparecer a nenhum evento futuro. Por que você não se inscreve em um?",
    "event": "evento  ",
    "challenge": "Desafio",
    "invited_you": "Convidou você",
    "public": "Público",
    "private": "Privado",
    "deleteEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Evento excluído com sucesso."
        }
    },
    "leaveEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Você saiu do evento"
        }
    },
    "editEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Evento atualizado com sucesso."
        }
    },
    "createEventToast": {
        "success": {
            "message": "Evento criado com sucesso.",
            "title": "%{eventName}"
        }
    },
    "contentIsDeletedOrInappropriate": "O conteúdo que você está tentando visualizar não está disponível no momento. Pode ter sido excluído pelo autor ou marcado como impróprio.",
    "start_time": "Horário de início",
    "end_time": "Horário de término",
    "event_type": "Evento de %{eventType}",
    "leave_event_modal": {
        "title": "Se você sair deste evento",
        "message": "Ele será excluído"
    },
    "leave_event ": "Tem certeza que deseja sair deste evento?",
    "create_event": "Criar evento",
    "created_by": "Criado por",
    "eventActionToast": {
        "danger": {
            "title": "Erro",
            "message": "Algo deu errado. "
        }
    },
    "continue": "Continuar",
    "wantExitTour": "Tem certeza que deseja sair do tour?",
    "exitTour": "Sair do tour",
    "deleveEventPopup": "Tem certeza que deseja excluir este evento?",
    "attendeesTitle": "Participantes",
    "userEvents": "Eventos de %{name}",
    "createEventIndicator": "Criando um evento",
    "inviteToEvent": "Convidar para evento",
    "noDescription": "Não há descrição.",
    "leaderboardIsEmpty": "Esta tabela de classificação está vazia ou pode ser que você precise rastrear a atividade dentro do período selecionado para visualizar.",
    "notParticipantingInAnyChallenges": "Você não está participando de nenhum desafio",
    "buttonLeaveEvent": "Sair do evento",
    "leaveEvent ": "Deixar %{name}?",
    "canceledCreatingChallenge": "A criação de %{challengeType} foi cancelada com sucesso",
    "swipeReadNotification": "Ler",
    "productTour": {
        "initialScreen": {
            "title": "Bem-vindo ao %{programName}!",
            "body": "Vamos fazer um tour e em alguns instantes você saberá o básico."
        },
        "dashboard": {
            "title": "Painel",
            "body": "Veja quantos %{pointsName} você tem e seu progresso em relação aos níveis. Em seguida, verifique a tabela de classificação para ver como você está se saindo."
        },
        "rewards": {
            "title": "Recompensas",
            "body": "Veja quantos %{rewardPointName} você tem e resgate-os na loja."
        },
        "goals": {
            "title": "Metas e desafios",
            "body": "Suas metas pessoais ativas, desafios com outras pessoas e tarefas especiais podem ser encontrados aqui."
        },
        "explore": {
            "title": "Explorar",
            "body": "Encontre desafios com outras pessoas, participe de comunidades para discutir seus interesses e descubra um novo artigo na biblioteca de bem-estar."
        },
        "me": {
            "title": "Eu",
            "body": "Descubra sua pontuação de bem-estar, verifique suas estatísticas e edite seu perfil e configurações aqui."
        },
        "finishScreen": {
            "title": "Você está pronto",
            "body": "Obrigado por completar o tour.",
            "button": "Vamos começar"
        },
        "skip": {
            "title": "Tem certeza que deseja pular o tour?",
            "body": "Isso vai encerrar o tour e você poderá começar imediatamente."
        }
    },
    "getTemporaryRewardRedemptionTokenToast": {
        "danger": {
            "title": "Falha de autenticação",
            "message": "Não foi possível prosseguir com o resgate da recompensa. Ocorreu um erro ao autenticar com o provedor de recompensa."
        }
    },
    "rewardRedemptionFailureToast": {
        "danger": {
            "title": "O resgate falhou",
            "message": "%{displayMessage}"
        }
    },
    "disclamerSectionTitle": "Antes de começar",
    "disclamerSectionMessage": "Consulte o seu profissional de saúde antes de iniciar qualquer novo programa de exercícios ou fazer mudanças no estilo de vida para garantir que eles são adequados para você.",
    "noEarchedAchievements": "Você ainda não obteve nenhuma conquista. Rastreie uma atividade para começar.",
    "noInProgressAchievements": "Você não tem conquistas em andamento.",
    "discardCreatingEventMessage": "Verifique se todos os campos obrigatórios foram inseridos",
    "discardCreatingEventTitle": "O evento não pode ser criado",
    "discardEditedEventTitle": "O evento não pode ser editado",
    "errorEventNameMessage": "O nome é obrigatório",
    "errorEventStartDateMessage": "A data de início é obrigatória",
    "errorEventEndDateMessage": "A data de término é obrigatória",
    "errorEventDateMessage": "A data de término não pode ser anterior à data de início",
    "noAccountsToLink": "Não há contas disponíveis para vincular a %{program_name}.",
    "accountLinkEmailChanged": "Seu endereço de e-mail foi atualizado. De agora em diante, faça login com sua conta vinculada.",
    "accountLinkSuccessful": "Sua conta foi vinculada com sucesso.",
    "edit_profile_nan_value": "O valor deve ser um número",
    "advancedLogIn": "Login avançado",
    "redemptionSessionExpiredToast": {
        "danger": {
            "title": "O resgate falhou",
            "message": "A sessão do pedido expirou. Tente fazer o pedido novamente."
        }
    },
    "left": "restantes",
    "eventsCarousel": {
        "emptyEvent": {
            "prompt": "Parece que não há eventos disponíveis para participar no momento. Por que você não cria um?"
        }
    },
    "reachedHighestLevel": "Você atingiu o nível mais alto!",
    "error": "Erro",
    "redeemRewardSuccessfulToast": {
        "success": {
            "title": "Resgate de recompensa",
            "message": "Seu pedido foi realizado"
        }
    },
    "redeemRewardComplete": "Resgate completo",
    "trackActivityTitle": {
        "oneUnit": "Rastrear: 1 %{unit} de %{activity} em %{date}",
        "nUnit": "Rastrear: %{activity} para %{date}"
    },
    "ssoAuthenticationFailure": "Falha de autenticação",
    "earnEvery": "Ganhe a cada %{frequency}",
    "earnOnce": "Ganhe apenas uma vez",
    "goalSettings": {
        "maximumSet": "Atualmente, você tem o máximo de 3 metas definidas.",
        "learnMore": "Saiba mais sobre a definição de metas"
    },
    "allowMarketingComms": "Envie-me comunicações promocionais",
    "allowPartnerMarketingComms": "Envie-me comunicações promocionais de parceiros",
    "noUpcomingAchievements": "Você não tem conquistas próximas.",
    "settingGoalToast": {
        "success": {
            "message": "Sua nova meta foi definida!"
        }
    },
    "authentication": {
        "saml": {
            "error": "Serviço indisponível no momento",
            "signin": "Login integrado",
            "signup": "Registro integrado"
        }
    },
    "monthName": {
        "january": "Janeiro",
        "february": "Fevereiro",
        "march": "Março",
        "april": "Abril",
        "may": "Maio",
        "june": "Junho",
        "july": "Julho",
        "august": "Agosto",
        "september": "Setembro",
        "october": "Outubro",
        "november": "Novembro",
        "december": "Dezembro"
    },
    "promotedForMe": "Em Destaque",
    "appRating": {
        "enjoying": "Está gostando do nosso aplicativo?",
        "feedback": "Você gostaria de fornecer um feedback?",
        "appStore": "Avalie-nos na App Store?",
        "googlePlay": "Avalie-nos no Google Play?",
        "notReally": "Na verdade, não",
        "yes": "Sim!",
        "sure": "Claro",
        "noThanks": "Não, obrigado",
        "notNow": "Agora não"
    },
    "getMobileApp": "Para usar %{programName} em seu smartphone, baixe %{appStoreName} da App Store ou do Google Play.",
    "newAppsDevicesDesign": {
        "getMobileApp": "Baixe o aplicativo %{programName}",
        "searchInAppStore": "Pesquise %{programName} na loja de aplicativos do seu dispositivo",
        "getMobileAppNoName": "Obtenha o aplicativo para dispositivo móvel"
    },
    "editorAlert": {
        "discardChanges": "Descartar alterações",
        "saveAndContinue": "Salvar e continuar",
        "title": "Alterações não salvas",
        "text": "Você aplicou algumas alterações que não foram salvas. O que você gostaria de fazer?"
    },
    "resources": "Recursos",
    "noResources": "Nenhum recurso disponível",
    "viewAllResources": "Ver todos os recursos",
    "language": "Idioma",
    "eventStarted": "Evento iniciado. Registro encerrado.",
    "Gender": "Gênero",
    "show": "Exibir",
    "hide": "Ocultar",
    "timeoutError": "Ops! Algo está demorando muito. Tente novamente mais tarde.",
    "SOT": {
        "sample_task": "Exemplo de tarefa"
    },
    "cache": {
        "new_version": "Uma nova versão está disponível!",
        "refresh_browser": "Clique aqui para atualizar seu navegador."
    },
    "welcomeUser": "Bem-vindo(a), %{userFirstName}!",
    "quarter": "trimestre",
    "completionReward": "Recompensa de conclusão",
    "bronzeLevel": "Nível bronze",
    "deviceAppSyncingOk": "Sincronização de dispositivo\/aplicativo ok",
    "deviceAppSyncingIssue": "Problema de sincronização de dispositivo\/aplicativo",
    "deviceAppSyncingError": "Erro de sincronização de dispositivo\/aplicativo",
    "lastSync": "Última sincronização",
    "period": "período",
    "yourDaySummary": "Seu dia até agora",
    "steps": "Etapas",
    "gender_non_binary": "Não binário ou não conformista",
    "take_survey": "Responda à pesquisa",
    "social": "Social",
    "finalDay": "Dia final",
    "leaderboard_position": "Posição na tabela de classificação",
    "signUp": {
        "apple": {
            "disconnectSettings": "Desconectar %{appName} de 'Senha e segurança do ID Apple' nas configurações do telefone para continuar a se cadastrar"
        }
    },
    "earnPoints": "Ganhe %{customPoints}. Suba de nível.",
    "getReward": "Obtenha %{rewardName}.",
    "buildHealthyHabits": "Crie hábitos saudáveis.",
    "highestLevelIndicator": "Você atingiu o nível mais alto!",
    "highestLevelIndicatorNew": "Você concluiu todos os níveis!",
    "trackYourActivity": "Para obter %{customPoints}, rastreie seus exercícios e atividades de bem-estar.",
    "levelUpToGetRewarded": "Conforme sobe de nível, você será recompensado com %{rewardName}.",
    "levelUpAndEarn": "Seu progresso é redefinido a cada %{period}, para que você possa subir de nível e ganhar mais e mais.",
    "levelUp": "Seu progresso é redefinido a cada %{period}, para que você possa subir de nível continuamente.",
    "goToLibrary": "Ir para a biblioteca",
    "updateEventIndicator": "Atualizando evento",
    "meTour": {
        "healthSurveyDisabled": "Verifique suas estatísticas e edite o perfil e as configurações aqui."
    },
    "createNewGoal": "Criar nova meta",
    "later": "Mais tarde",
    "bonusChallenge": "Desafio bônus",
    "bonusChallengeInfo": {
        "withReward": "Você ganhará %{amount} %{points} de bônus por completar pelo menos 85% deste %{challengeType}.",
        "noReward": "Você receberá um bônus por completar pelo menos 85% deste desafio.",
        "boldText": "%{amount} %{points} de bônus",
        "noRewardChallengeType": "Você ganhará um bônus por completar pelo menos 85% deste(a) %{challengeType}."
    },
    "defaultApp": "Seu aplicativo de saúde padrão",
    "bonusGoal": {
        "additionalInfo": "Se toda a sua atividade foi rastreada usando um aplicativo ou dispositivo conectado, você receberá %{points} de bônus em dobro!",
        "additionalInfoNew": {
            "paragraph2": "%{points} de bônus são concedidos após a meta ser finalizada. Você não receberá %{points} de bônus por metas que deixar antecipadamente."
        },
        "boldText": "%{points} de bônus em dobro!",
        "markTitle": "Meta de bônus"
    },
    "notify_me": "Me avise",
    "bonusChallengeReward": "Recompensa de desafio bônus",
    "forCompletingChallenge": "Por completar %{challengeName}",
    "notifications_text": "As notificações ajudam você a cumprir suas metas e acompanhar as conversas.",
    "type_here": "Digite aqui",
    "bonusEarned": "Bônus obtido",
    "youEarnedBonus": "Você ganhou este bônus!",
    "inviteOthersToChallenge": "Convide outras pessoas para participar do desafio",
    "inviteOthersToYourTeam": "Convide outras pessoas para sua equipe",
    "manageTeam": "Gerenciar equipe",
    "ft": "ft",
    "lbs": "lbs",
    "cm": "cm",
    "kg": "kg",
    "community": "comunidade",
    "chooseActivity": "Escolha a atividade",
    "Recent": "Recente",
    "noActivities": "Sem atividades correspondentes",
    "photoChooseText": "Escolher",
    "photoCancelText": "Cancelar",
    "signIn": {
        "missingEmail": "Falta o endereço de e-mail",
        "missingPassword": "Certifique-se de fornecer a senha",
        "invalidLogin": "Login inválido",
        "accountLocked": "Sua conta está bloqueada. Entre em contato com o administrador",
        "accountMayNotExist": "Não temos uma conta para este endereço de e-mail. Registre-se para criar uma conta.",
        "wrongPassword": "Senha incorreta. Tente novamente ou clique em \"Esqueci a senha\" para redefini-la."
    },
    "deleteGoalBonusPoints": "Se você ainda não ganhou o bônus associado, não será mais possível ganhar.",
    "havent_tracked_goal": "Você não rastreou nenhuma atividade para esta meta",
    "trackActivity": {
        "search": "Pesquisar atividades...",
        "text": "Rastrear atividade",
        "done": "Concluído",
        "discardChanges": "Descartar alterações?",
        "discardMessage": "Tem certeza que deseja sair e descartar seu progresso?",
        "discard": "Descartar",
        "limitMessage": "Você só pode rastrear até sete dias por vez.",
        "inputDescription": "Quantidade de %{activity} para %{date}",
        "gracePeriod": "Você tem %{n} %{text} para rastrear qualquer atividade perdida"
    },
    "dates": "Datas",
    "pickDates": "Escolha outras datas",
    "selectDates": "Selecione as datas",
    "limitReached": "Você atingiu o limite",
    "activity": "Atividade",
    "keepUpTheGoodWork": "Continue assim!",
    "activityTracked": "Atividade rastreada",
    "new": "Novo",
    "newFeatureTitle": "Rastreamento de atividades mais fácil e rápido",
    "newFeatureText": "Quer você esteja rastreando atividades de hoje, do passado ou de vários dias, acreditamos que vai adorar a nova experiência.",
    "gotIt": "Entendi!",
    "frequencyViewHistory": "Veja o detalhamento %{frequency}",
    "challengeDetails": {
        "trackTheseActivities": "Rastreie qualquer uma dessas atividades para progredir neste(a) %{challengeType}."
    },
    "member": "membro",
    "weeklyBreakdown": "Detalhamento semanal",
    "setGoals": {
        "earnPointsText": {
            "start": "Ganhe",
            "end": "por definir sua primeira meta!"
        }
    },
    "weeklyGoalEnded": "A semana terminou em",
    "weekFinished": "Você terminou uma semana de",
    "restartGoal": {
        "daysLeftToTrack": "Você ainda tem %{quantity} %{days} para rastrear qualquer progresso esquecido da semana passada.",
        "weekEnded": "Essa semana acabou.",
        "timesUp": "O tempo acabou!",
        "period": {
            "title": "Período da meta",
            "text": "De segunda a domingo, toda semana"
        }
    },
    "membersPlural": "Membros",
    "startedADayAgo": "Iniciado há 1 dia",
    "goalRestarted": "Você reiniciou esta meta",
    "weeklyGoals": "Metas semanais",
    "weeklyGoalsDescription": "As metas semanais se renovam todas as segundas-feiras, para que você possa manter um hábito saudável por um longo período.",
    "challengeEnded": "Este(a) %{challengeType} terminou",
    "goalEndedModalTitle": "O tempo acabou! O(a) %{challengeType} terminou!",
    "yourProgress": "Seu progresso",
    "earn_withRewards": "Acompanhe sua atividade saudável para ganhar (%{pts}) e passar de nível. Ao subir de nível, você receberá %{currency}.",
    "earn_noRewards": "Suivez votre exercice et votre activité de bien-être pour gagner (%{pts}) et passer au niveau supérieur.",
    "currentPeriod": "Período atual",
    "currentScore": "Pontuação atual",
    "viewActivityLog": "Ver registro de atividades",
    "balanceHistory": "Meu histórico de saldo",
    "mymedibank": {
        "underAge": {
            "error": "O aplicativo Live Better está disponível apenas para usuários maiores de 18 anos. Consulte os Termos e Condições do Live Better para obter mais informações."
        }
    },
    "enhancedHomePageInfo": "Nós arrumamos a página inicial! Agora é mais fácil ver seus desafios e metas. É hora de rastrear!",
    "levelUpTitle": "Subir de nível",
    "levelUpDescription": "Passe de nível rastreando atividades e completando metas e desafios. Conforme sobe de nível, você será recompensado com %{currency}!",
    "achievementsDescription": "Desbloqueie estas medalhas especiais para ganhar %{currency}. Clique em uma medalha para ver o que você precisa fazer.",
    "bonusChallengesDescription": "Participe e conclua os desafios que têm bônus de %{currency}.",
    "earnWithPartners": {
        "title": "Ganhe com parceiros",
        "description": "Os membros do Medibank com cobertura hospitalar ou extras podem ganhar pontos em compras\/atividades elegíveis com parceiros."
    },
    "browseAllPartners": "Procurar todos os parceiros",
    "resetsIn": "Reinicia em %{daysNumber} dias",
    "thisIsALot": "Isso é muito!",
    "areYouSure": "Você tem certeza?",
    "trackingALotMessage": {
        "days": "Você está rastreando mais de 2000 %{customPoints} em %{daysNum} dias. Isso é muito!",
        "day": "Você está rastreando mais de 2000 %{customPoints} em 1 dia. Isso é muito!"
    },
    "amSure": "Tenho certeza",
    "activeMinutesAndSleep": {
        "title": "Rastreamento de dispositivo para minutos ativos e sono",
        "description": "Seu dispositivo registra minutos ativos durante atividades físicas de intensidade moderada ou alta - esse é um exercício de boa qualidade! Usando um dispositivo para rastrear seu sono? Você ganhará %{points} por isso também!"
    },
    "hourShort": "h",
    "hoursShort": "h",
    "secondsShort": "s",
    "watchToEarn": "Assistir para ganhar",
    "oneParticipant": "1 participante",
    "oneTeam": "1 equipe",
    "numberOfTeams": "%{num} equipes",
    "inviteToYourTeam": "Convide para sua equipe",
    "inviteToThisChallenge": "Convide para este desafio",
    "challengeInstructionText": "Rastreie esta atividade para progredir em seu %{challengeType}.",
    "showLess": "Mostrar menos",
    "startsTomorrow": "Começa amanhã",
    "deadlineDayLeft": "dia restante",
    "deadlineDaysLeft": "dias restantes",
    "deviceBonus": "bônus de dispositivo",
    "appsAndDevices": {
        "header": "Aplicativos e dispositivos",
        "linked": "Esses aplicativos e dispositivos vinculados estão rastreando este %{challengeType}:",
        "noLinked": "Nenhum aplicativo ou dispositivo aplicável vinculado",
        "link": "Vincule seu telefone, relógio ou aplicativo para rastrear automaticamente."
    },
    "yourGoals": "Suas metas",
    "yourChallenges": "Seus desafios",
    "position": "Posição",
    "team_success": "Sucesso da equipe",
    "starts_in": "Começa em",
    "team_challenge": "Desafio de equipe",
    "your_progress_today": "Seu progresso hoje",
    "your_daily_avarage": "Sua média diária é",
    "this_week_progress": "Progresso desta semana",
    "this_month_progress": "Progresso deste mês",
    "overall_progress": "Progresso geral",
    "complete": "concluído",
    "overallSuccess": "Sucesso geral",
    "teamSuccessAverage": "Média de sucesso da equipe",
    "progressDetails": "Detalhes do progresso",
    "dayStreak": "Sequência de %{n} dias!",
    "weekStreak": "Sequência de %{n} semanas!",
    "dailyProgress": "Progresso diário",
    "participantsSuccessCount": {
        "overall": "%{amount} de %{total} participantes atingiram a meta",
        "day": "%{amount} de %{total} participantes atingiram a meta hoje",
        "week": "%{amount} de %{total} participantes atingiram a meta esta semana",
        "month": "%{amount} de %{total} participantes atingiram a meta este mês"
    },
    "doubleBonusShort": "Bônus em dobro!",
    "doubleBonusLong": "Você ganhou bônus em dobro!",
    "recommendedGoalDescription": "As metas ajudam você a acompanhar seu progresso e a se manter motivado!",
    "noParticipation": "Nenhuma participação",
    "nothingToShow": "Parece que não há nada para mostrar agora",
    "yourTeam": "Sua equipe",
    "no_activity_title": "Nenhuma atividade",
    "brandSupport": {
        "description": "Adicionamos suporte para sincronização de atividades com smartwatches Polar e Withings. É hora de começar!"
    },
    "no_tracked_activities": "Você ainda não rastreou nenhuma atividade.",
    "button_leave_community": "Sair da comunidade",
    "button_delete_challenge": "Excluir %{challengeType}",
    "button_delete_community": "Excluir comunidade",
    "button_delete_activity": "Excluir atividade",
    "library_header_description": "Conteúdo original para ensinar, envolver e inspirar você em sua jornada de bem-estar.",
    "library_searchbar": "Pesquisar na biblioteca…",
    "library_page_header": "Conteúdo original para ensinar, envolver e inspirar você em sua jornada de bem-estar.",
    "onboarding_button_title": "Terminei",
    "refresh_bar": "Clique aqui para atualizar",
    "content": {
        "min_read": "Leitura mínima de %{readingTime}"
    },
    "noMembers": "Nenhum membro",
    "saved": "Salvo",
    "forYou": "Para você",
    "min read (Note: min as in minutes)": "",
    "send me program related email notifications": "",
    "send me weekly email updates": "",
    "you can earn this bade once every quarter": "",
    "badgeInstruction": "%{badgeInstruction} até",
    "youCanEarnThisBadge": "Ganhe esta insígnia a cada %{period}",
    "emailPreferences": "Preferências de e-mail",
    "unsubscribeText": "Desativar todas as atualizações por e-mail",
    "savingText": "Salvando...",
    "wrongTryLater": "Algo deu errado. Tente novamente mais tarde.",
    "preferencesSaved": "Preferências salvas",
    "recommendedForYou": "Recomendado para você",
    "formerMember": {
        "label": "Ex-membro"
    },
    "selectionsFromLibrary": "Seleções da nossa biblioteca escolhidas para você",
    "goalsInfo": {
        "desc1": "se concentrar em melhorar o seu bem-estar.",
        "desc2": "Você definiu o número máximo de metas."
    },
    "createMyOwn": "Criar o(a) meu(inha)",
    "isAllSet": "está pronto!",
    "undoLabel": "Desfazer",
    "terms": "Termos",
    "placeOrder": "Fazer pedido",
    "item": "Item",
    "redeemFor": "Resgatar por",
    "confirmYourOrder": "Confirmar seu pedido",
    "orderComplete": "Pedido concluído",
    "redeemedFor": "Resgatado por",
    "orderDetails": "Detalhes do pedido",
    "bonusGoalReward": "Recompensa de meta de bônus",
    "orderSummary": "Resumo do pedido",
    "logoutSSO": {
        "title": "Você saiu de %{programName}.",
        "description": "Vejo você novamente em breve!",
        "signinAgain": "Clique aqui para entrar novamente"
    },
    "nothing_to_show": "Nada para mostrar no momento",
    "no_saved_content": "Você não tem nenhum conteúdo salvo",
    "restarts_every_week": "Reinicia toda semana",
    "myGoals": "Minhas metas",
    "goalGallery": "Galeria de metas",
    "share_smth": "Compartilhe alguma coisa…",
    "newFeatureModal": {
        "smartGoal": {
            "title": "Nossa meta de passos ficou mais inteligente!",
            "description": "Suas semanas são sempre diferentes - agora seus objetivos também são! \n Com o Modo Inteligente, sua meta de passos será ajustada com base nas atividades da vida real.\n Ela é definida tendo em mente seu sucesso e bem-estar.",
            "action": "Confira!"
        },
        "mePage": {
            "title": "O novo eu",
            "description": "Redesenhamos a seção Eu para facilitar a localização das coisas que lhe interessam – confira!",
            "letsSeeBtn": "Vamos ver!",
            "llaterBtn": "Talvez mais tarde"
        },
        "bellEAP": {
            "title": "Bem-vindo à plataforma on-line do Programa de Assistência ao Empregado e Família!",
            "description": "Descubra as ferramentas e serviços para auxiliar o bem-estar e os desafios de vida disponíveis para você e para os membros da família elegíveis",
            "button": "Conecte-se agora ou visite a página Links Rápidos a qualquer momento"
        },
        "quickActivityLogView": {
            "title": " Uma maneira mais rápida de ver sua atividade recente",
            "description": "Agora você pode clicar na barra de progresso para ver seu registro de atividades."
        }
    },
    "goalSmartMode": {
        "title": "Modo Inteligente",
        "description": "Obtenha metas semanais personalizadas com base em seu nível de atividade recente.",
        "status": "O Modo Inteligente está %{status} para esta meta.",
        "infoModal": {
            "descriptionOne": "Quando o Modo Inteligente estiver ativado, o objeto desta meta mudará semanalmente com base em seu nível de atividade recente.",
            "descriptionTwo": "Vamos desafiar você na medida certa para prepará-lo para o sucesso.",
            "instructions": ""
        },
        "settings": {
            "switch": "Ativar o Modo Inteligente para minha meta de passos",
            "description": "Quando o Modo Inteligente estiver ativado, você receberá uma nova meta de passos no início de cada semana."
        },
        "enableSmartMode": "Ativar Modo Inteligente",
        "settingsModal": {
            "descriptionTurnOn": "O objetivo da sua meta de passos mudará toda semana com base em sua atividade",
            "descriptionTurnOff": "O objetivo da sua meta de passos não será mais personalizado toda semana"
        }
    },
    "On": "Ativado",
    "Off": "Desativado",
    "top_posts": "Principais postagens",
    "most_recent": "Mais recente",
    "browseByTopic": "Navegue por tópico",
    "video": "Vídeo",
    "enable": "Ativar",
    "turnOff": "Desativar",
    "new_post": "Nova publicação",
    "new_post_in": "Nova publicação em",
    "dailyTarget": "Objetivo diário",
    "dailyTargetForWeek": "Objetivo diário para a semana",
    "showMyActivityLog": "Mostrar meu registro de atividades",
    "usersReacted": {
        "oneOther": "%{userName} e 1 outro",
        "multipleOthers": "%{userName} e %{count} outros"
    },
    "reactionsModal": {
        "title": "Mais maneiras de comemorar",
        "description": "Torça por seus colegas com novas reações em postagens sociais!"
    },
    "account": "Conta",
    "myWellbeingProfile": "Meu perfil de bem-estar",
    "physicalDetailsDescription": "Esta informação é necessária para calcular sua pontuação de bem-estar",
    "wellbeingInterests": "Interesses de bem-estar",
    "myWellbeingInterests": "Meus interesses de bem-estar",
    "preferredNameOptional": "Nome preferido (opcional)",
    "basicPhysicalDetails": "Detalhes físicos básicos",
    "notRegistered": {
        "infoModal": {
            "title": "Não conseguimos encontrar você",
            "notInSystem": "não está em nosso sistema.",
            "correctEmail": "Certifique-se de usar a conta correta (geralmente um endereço de e-mail comercial) e verifique se há erros de digitação.",
            "emailHelp": "Para obter mais ajuda, envie um e-mail para nossa equipe de suporte em"
        }
    },
    "dontHaveAccount": "Não tem conta?",
    "wasThisHelpful": "Isto foi útil?",
    "healthScoreFeedbackModal": {
        "emojiSection": "Qual a utilidade desta página e da sua pontuação de bem-estar?",
        "commentSectionText": "Como elas podem melhorar?",
        "commentSectionPlaceholder": "Adicione um comentário...",
        "thankYouModal": "Agradecemos por seus comentários!"
    },
    "number_connected": "%{numDevices} conectados",
    "searchPlaceHolder": "Pesquisar...",
    "noTeamsFound": "Nenhuma equipe encontrada",
    "join_a_challenge": "Participar de um desafio",
    "me_page_titles": {
        "goal": {
            "singular": "meta",
            "plural": "metas"
        },
        "challenge": {
            "singular": "desafio",
            "plural": "desafios"
        }
    },
    "seeMoreText": "...ver mais",
    "adjust_entry": "Ajuste a entrada.",
    "overTracking": {
        "title": "Aviso de rastreamento excessivo",
        "desc1": {
            "singular": "Essa entrada será verificada.",
            "plural": "Essas entradas serão verificadas."
        },
        "desc2": "O rastreamento excessivo intencional pode resultar na suspensão da conta.",
        "button_edit": "Editar minhas entradas",
        "button_confirm": "Enviar como está"
    },
    "oneEventAttendee": "1 participante",
    "multipleEventAttendees": "%{num} participantes",
    "to": "para",
    "eventBonusFull": "Você ganhará %{number} bonus %{points} por participar deste evento.",
    "eventBonusBold": "%{number} bonus %{points}",
    "didYouLikeArticle": "Gostou deste artigo?",
    "didYouLikeVideo": "Gostou deste vídeo?",
    "tellUsMore": "Conte-nos mais...",
    "thanksForFeedback": "Agradecemos por seus comentários!",
    "challengesSubtitle": "Alcance um objetivo junto com outros participantes ou jogue para vencer!",
    "appStoreNameSprout": "Sprout at Work",
    "appStoreNameLiveBetter": "Live Better do Medibank",
    "appStoreNameTelus": "TELUS Health Wellbeing",
    "huaweiStoreUrlSprout": "https:\/\/appgallery.huawei.com\/app\/C104993765",
    "telusHealthVirtualCare": "Virtual Care da Telus Health",
    "virtualCare": "Virtual Care",
    "changePassword": {
        "telus": {
            "info": "Sua senha é gerenciada através da sua conta %{telusVC}.",
            "button": "Alterar minha senha %{virtualCare}"
        }
    },
    "actions": "ações",
    "onAndUpcoming": "Atuais e futuros",
    "termsAndPrivacyPolicyNew": "Ao continuar, você concorda com",
    "invitedToTeam": "Convidado para a equipe de %{firstName} %{lastName}",
    "decline": "Recusar",
    "invitedToChallenge": "Convidado por %{firstName} %{lastName}",
    "goalsCard": {
        "emptyStateTitle": "Você não tem metas definidas"
    },
    "huaweiStoreUrlTelus": "https:\/\/appgallery.huawei.com\/app\/C107357173",
    "challengesCard": {
        "emptyStateTitle": "Você não está participando de nenhum desafio",
        "buttonLabel": "Explorar desafios"
    },
    "menu": "Menu",
    "everyone": "Todos",
    "confirmEmployeeID": "Confirmar ID de empregado",
    "employeeIDNoMatch": "Esses IDs ainda não correspondem",
    "hidePost": "Ocultar publicações de %{ownerName}",
    "hidingUserPostToast": {
        "success": {
            "title": "Usuário ocultado",
            "message": "Você não verá mais publicações deste usuário."
        }
    },
    "moderateHideUserDescription": "Ocultar publicações deste usuário removerá o conteúdo específico do usuário do stream.",
    "startsInOneDay": "Começa em 1 dia",
    "endsInOneDay": "Termina em 1 dia",
    "endsToday": "Termina hoje",
    "hrisEmployeeID": {
        "infoModal": {
            "notInSystem": "não está em nosso sistema. Você digitou corretamente?",
            "administrator": "Se você for um empregado novo, talvez ainda não tenhamos seu ID de empregado. Pergunte ao seu administrador quando tentar novamente.",
            "emailNotInSystem": "Se você for um empregado novo, pode ser que seu e-mail ainda não tenha sido adicionado ao nosso sistema. Pergunte ao seu administrador quando tentar novamente.",
            "eligibleEmail": "não é um endereço de e-mail válido. Você digitou corretamente?"
        }
    },
    "oneMember": "1 membro",
    "programCode": {
        "infoModal": {
            "unique": "Sua empresa possui um código de programa exclusivo que geralmente é fornecido a você por e-mail.",
            "support": "Se não conseguir encontrar seu código, entre em contato com o administrador do programa de bem-estar ou envie um e-mail para support@sproutatwork.com com o nome da sua empresa."
        },
        "instructions": "Insira o código de programa fornecido por seu empregador para começar"
    },
    "whatsMyProgramCode": "Qual é o meu código de programa?",
    "enjoyApp": "Aproveite nosso aplicativo para dispositivo móvel",
    "programCodeLabel": "Código de programa",
    "createdByMembersChallenges": "Criado por membros",
    "invites": "Convites",
    "recommendedContentTitle": "Escolhas da biblioteca para você",
    "amountExchanged": "Quantidade trocada",
    "orderStatus": "Status do pedido",
    "orderSuccessfulyyItemForConfirmation": "Pedido realizado! Uma confirmação foi enviada para %{email}.",
    "orderedOnDateText": "Pedido em %{orderCreatedTime}",
    "personalize": {
        "communities": {
            "title": "Participe de comunidades",
            "description": "As comunidades conectam pessoas com interesses comuns. Você pode entrar ou sair das comunidades a qualquer momento."
        },
        "objectives": {
            "title": "Meus objetivos",
            "description": "O que podemos ajudar você a começar ou manter? Usaremos isso para melhorar suas recomendações."
        },
        "topics": {
            "title": "Meus tópicos de bem-estar",
            "description": "Você verá mais conteúdo de orientações e dicas sobre essas seleções."
        }
    },
    "recommendedCardDesc": "Defina até três metas para se concentrar em melhorar seu bem-estar",
    "accessibility": {
        "track_activity": "Rastrear atividade",
        "cardbody": "Corpo do cartão",
        "cardcontainer": "Contêiner do cartão",
        "cardfooter": "Rodapé do cartão",
        "unstartedChallengeHeader": "Desafio não iniciado",
        "activeOrEndedChallengeWrapper": "Encerramento do desafio",
        "activeOrEndedChallengeHeader": "Cabeçalho do desafio",
        "goalHeader": "Cabeçalho da meta",
        "openOptions": "Opções abertas"
    },
    "teams": {
        "teamInvites": "Convites de equipes",
        "findTeam": "Encontrar uma equipe",
        "teamFull": "A equipe está cheia"
    },
    "deleteAccountText": "Excluir permanentemente sua conta do Sprout At Work e todos os seus dados",
    "deleteAccountButtonTitle": "Excluir minha conta",
    "joinTeamActionSheetText": "Junte-se a uma equipe ou crie uma para participar deste desafio",
    "frequencyNone": "nenhum(a)",
    "quickLinkTitle": "Links Rápidos",
    "moreTab": "Mais",
    "addedBy": "Adicionado por %{companyName}",
    "teamsTitle": "Equipes",
    "helpAndSupport": "Ajuda e suporte do aplicativo",
    "feedbackTitle": "Dar feedback",
    "feedbackDescription": "Conte pra gente o que você gosta no aplicativo e o que podemos melhorar.",
    "leaveTeamAction": "Sair da equipe",
    "teamActions": "Ações de equipe",
    "leaveTeamLeaveChallenge": "Sair desta equipe significa que você está abandonando o desafio. Você precisará ingressar em uma equipe para continuar participando.",
    "familyMembers": "Membros da família",
    "familyMembersDescription": "Os membros da família devem ter mais de 16 anos. Eles terão acesso e visibilidade total em toda a plataforma.",
    "learnMoreButton": "Saiba mais",
    "thvcSelection": {
        "signUpUsingTelus": "Cadastre-se usando sua conta Virtual Care da TELUS Health",
        "loginGetStarted": "Faça login no Virtual Care para começar",
        "haveAccount": "Você tem uma conta Virtual Care?",
        "emailHelp": "Precisa de ajuda? Entre em contato com nossa equipe de suporte em",
        "yes": "Sim",
        "signMeUp": "Não, cadastre-me"
    },
    "inviteFamilyMember": {
        "label": "Convidar membro da família",
        "btn": "Enviar convite",
        "email": "Endereço de email*",
        "firstName": "Nome*",
        "lastName": "Sobrenome*",
        "approval": "Confirmo que tenho autorização para convidar este membro da família para %{company}",
        "multiSelect1": "Este membro da família é maior de idade na sua região?",
        "multiSelect2": "Este membro da família tem pelo menos 16 anos?",
        "confirmTermsPolicy": "Confirmo que sou o responsável legal desta pessoa. Na minha opinião, o dependente tem maturidade suficiente para concordar com a utilização da plataforma, e eu permito que ele faça sua adesão. Explicarei ao dependente a necessidade de uma conduta responsável na plataforma e a forma como a plataforma coleta e utiliza os dados.",
        "onTheirBehalf": "em nome deles.",
        "confirm": "Sim, eu confirmo o que foi dito acima",
        "warning": "O membro da família deve ter pelo menos 16 anos para se inscrever",
        "errorMsg": "Revise os erros antes de tentar prosseguir"
    },
    "deleteFamilyMember": {
        "desc": "A exclusão da conta de um membro da família é permanente.",
        "btn": "Excluir membro da família",
        "confirmation": {
            "title": "Membro da família excluído",
            "desc": "A conta de %{fullName} foi excluída"
        },
        "areYouSure": "Tem certeza de que deseja excluir a conta de %{fullName}?"
    },
    "familyInvitationStatus": {
        "active": "Ativo",
        "sent": "Convite enviado"
    },
    "familyInvitationSent": {
        "title": "E-mail de convite enviado",
        "desc": "Convite enviado para %{fullName}"
    },
    "programCodeSignup": "Use o %{programCodeLabel} %{programCode} depois de clicar em '%{signUpLabel}'",
    "notJoinedCommunityLabel": "Participe desta comunidade para ver o que os membros estão compartilhando",
    "moda": {
        "installApp": {
            "title": "Observação: os membros do Moda Health só podem acessar o Sprout at Work por meio do Painel de Membros.",
            "subtitle": "Para usar Sprout at Workno seu smartphone:",
            "stepOneA": "1. Instale o aplicativo para dispositivo móvel Sprout at Work.",
            "stepOneB": "Não se inscreva nem faça login no aplicativo móvel.",
            "stepTwo": "2. Faça login no seu Painel de Membros no seu celular",
            "stepThree": "3. Navegue até o programa de bem-estar Sprout e siga esse link. Ele deve abrir o aplicativo móvel Sprout at Work."
        }
    },
    "HRISLocationSelection": {
        "title": "De que país você trabalha?"
    },
    "visibilitySettings": {
        "title": "Configurações de visibilidade",
        "desc1": "Posso ficar visível para outros membros do aplicativo Wellbeing na sua empresa?",
        "desc2": "Você sempre pode mudar isso mais tarde.",
        "moreTextQ1": "O que outras pessoas podem ver?",
        "moreTextAnswer1": "Seu nome, foto do perfil e detalhes básicos do perfil (como departamento e localização) podem ser vistos por pessoas da sua empresa. Isso torna o aplicativo mais social e divertido.",
        "moreTextQ2": "Onde eu apareço?",
        "moreTextAnswer2": "Você será mostrado como participante dos desafios, comunidades e eventos dos quais participa, nas tabelas de classificação e nos resultados de pesquisa. Você pode ajustar isso mais tarde.",
        "moreTextAnswer3": "Não compartilhamos nem mostramos suas informações pessoais de saúde, como altura, peso ou a atividade que você monitora.",
        "btnAgree": "Está tudo bem em me mostrar",
        "btnDisagree": "Não deixe que outros membros me vejam"
    },
    "privacyPolicyReadMore": "Para saber mais, leia nossa Política de Privacidade",
    "tellMeMore": "Conte-me mais",
    "helpUsImprove": {
        "title": "Ajude-nos a melhorar",
        "desc1": "Usamos ferramentas que registram dados de uso anônimos. Ver tendências no que as pessoas veem e clicam nos ajuda a melhorar o aplicativo.",
        "desc2": "Você pode desligar isso a qualquer momento.",
        "moreTextQ1": "O que olhamos",
        "moreTextAnswer1": "Estamos interessados ​​em tendências e estatísticas gerais, por isso não analisamos os dados a nível individual.",
        "moreTextQ2": "Não compartilhamos seus dados",
        "moreTextAnswer2": "Esses dados estão disponíveis apenas para as pessoas que criam este aplicativo para ajudar a torná-lo melhor. Não os compartilhamos com outras empresas, incluindo seu empregador.",
        "moreTextQ3": "Seus dados são anônimos",
        "moreTextAnswer3": "Nossas ferramentas não registram seu nome, localização exata ou qualquer informação pessoal de saúde.",
        "btnAgree": "Rastrear meu uso anonimamente",
        "btnDisagree": "Não concordo com rastreamento"
    },
    "deleteAccountTextAppName": "Exclua permanentemente sua conta %{appName} e todos os seus dados",
    "anonymousMember": "Membro Anônimo",
    "activitiesToTrack": {
        "title": "Atividades para rastrear"
    },
    "includedInMembership": "Incluído na sua assinatura",
    "invalidDate": "Data inválida",
    "discardsStreamPost": {
        "discardTitle": "Descartar postagem?",
        "discardChangesTitle": "Descartar alterações?",
        "discardPostText": "Tem certeza de que deseja descartar sua postagem?",
        "discardPostChangesText": "Tem certeza de que deseja descartar suas alterações?"
    },
    "trackActivityModalTitle": "Acompanhe para %{data}",
    "noPosts": "Nenhuma postagem para ver",
    "goalIcon": "Ícone de meta",
    "resetsOn": "Reinicia em %{date}",
    "clickForHelp": "Clique aqui para Ajuda",
    "trackActivityInputLabel": "Digite %{unit} %{activityName} %{dateFormat}",
    "itemsFound": "Itens encontrados",
    "tagState": {
        "active": "Ativo",
        "notActive": "Não ativo"
    },
    "bonusCheckmarkLabel": "Recebeu %{bonusLabel} pontos de bônus pela conclusão",
    "searchBar": {
        "searching": "pesquisando %{term}",
        "result": "resultados da pesquisa"
    },
    "activityProgress": "Progresso da atividade - %{levelName} %{percentFilled}% - Redefinições em %{daysLeft} dias",
    "bookmark": {
        "remove": "Remover dos itens salvos",
        "save": "Salve este item"
    },
    "bonusMark": {
        "earn": "Ganhe %{qty} %{pontos}",
        "earned": "Você ganhou %{qty} %{pontos}"
    },
    "tabToTrackActivity": "Toque para monitorar atividades",
    "videoElementLabel": "%{title}, duração %{duration}, toque duas vezes para reproduzir o vídeo",
    "updatedPoliciesPopup": {
        "title": "Atualizamos nossos termos",
        "details": "Recomendamos que você leia nossas políticas atualizadas abaixo:",
        "disclaimer": "Ao clicar no botão abaixo, você concorda e reconhece as políticas atualizadas.",
        "agree": "Concordo"
    },
    "editActivityLog": {
        "canNotEditItem": "Você não pode editar esta entrada",
        "canNotEditItemDescription": "A edição não está disponível para atividades sincronizadas de dispositivos ou aplicativos.",
        "updatedItem": "Atividade atualizada",
        "updatedItemDescription": "Suas alterações foram salvas."
    },
    "login_with_email": "Entrar com e-mail",
    "healthconnect_not_available": "Não é possível conectar ao Health Connect. No aplicativo Health Connect, certifique-se de que as permissões estejam habilitadas.",
    "registrationField": {
        "required": {
            "firstName": "Por favor, insira seu primeiro nome",
            "lastName": "Por favor, insira seu sobrenome",
            "email": "Por favor, insira um endereço de e-mail válido",
            "password": "Por favor, insira uma senha válida"
        }
    },
    "settingsErrorMessage": {
        "firstName": "Por favor insira seu primeiro nome",
        "lastName": "Por favor insira seu sobrenome"
    },
    "requiredValidValue": "Por favor insira um valor válido para seu %{value}",
    "passwordHidden": "Senha oculta, toque para mostrar a senha",
    "passwordShown": "Senha mostrada, toque para ocultar a senha",
    "libraryHeaderContent": {
        "category": "",
        "points": "Ganhe %{pontos} pontos."
    },
    "scoreCurrentPeriod": "%{text} é de %{startDate} a %{endDate}",
    "scoreCurrent": "%{texto} equivale a %{pontos} pontos",
    "abbotResetPasswordModal": {
        "title": "Você está tentando acessar uma conta do ano passado?",
        "text": " Se você se inscreveu no desafio do ano passado, essa conta não funcionará mais. Você precisa se inscrever neste ano.",
        "goToResetPasswordBtn": "Eu me inscrevi em %{currentYear}",
        "goToSignupBtn": "Não me inscrevo há %{currentYear}"
    },
    "challengeRegistrationClosed": "Inscrições encerradas - O desafio começou",
    "stopSupportGoogleFit": {
        "banner": {
            "title": "O Google Fit será descontinuado",
            "description": "Mude para o Health Connect para continuar registrando automaticamente suas atividades.",
            "linkBtn": "Mudar para Health Connect"
        },
        "newFeatureModal": {
            "label": "Ação necessária",
            "title": "O Google Fit não oferece mais suporte à sincronização de atividades",
            "web": {
                "doNotHaveApp": "Ainda não tem nosso aplicativo?",
                "getAppText": "Baixe aqui,",
                "dateNotIncludedDescription": "Use seu smartphone para mudar para o Google's Health Connect.",
                "dateIncludedDescription": "Removeremos a integração com o Google Fit em %{date}. Use seu smartphone para mudar para o Google's Health Connect."
            },
            "mobile": {
                "dateNotIncludedDescription": "Mude para o Health Connect para continuar registrando automaticamente suas atividades.",
                "dateIncludedDescription": "Removeremos a integração com o Google Fit em %{date}. Mude para o Health Connect para continuar registrando automaticamente suas atividades.",
                "buttonLabel": "Mudar para Health Connect"
            }
        }
    },
    "RBCTaxableRewardWarning": "Observe que quaisquer recompensas resgatadas por meio da plataforma de bem-estar serão consideradas um benefício tributável e o valor correspondente será refletido como renda em seu contracheque."
};